import cssSyllabusCatalog from "./data/cssSyllabusCatalog.json";

export const brand = {
  name: "Aspirant CSS",
  domain: "aspirant.com.pk",
  url: "https://www.aspirant.com.pk",
  logo: `${process.env.PUBLIC_URL || ""}/logo-320.png`,
  cover: `${process.env.PUBLIC_URL || ""}/cover.jpg`
};

export const appStores = {
  android: {
    platform: "Android",
    storeName: "Google Play",
    url: "https://play.google.com/store/apps/details?id=pk.com.aspirant",
    identifier: "pk.com.aspirant",
    version: "3.0"
  },
  ios: {
    platform: "iOS",
    storeName: "Apple App Store",
    url: "https://apps.apple.com/pk/app/aspirant-css-mpt-exam-prep/id6792441265",
    identifier: "6792441265",
    bundleIdentifier: "pk.com.aspirant",
    version: "1.3"
  }
};

export const appFeatureGroups = [
  {
    id: "subjects",
    shortLabel: "LEARN",
    title: "CSS subjects, syllabus and lectures",
    summary: "Move from the official subject boundary to organised learning without losing your place.",
    features: [
      { title: "Compulsory and optional subjects", text: "Browse the complete CSS subject catalogue in FPSC group order, with clear subject-fit labels." },
      { title: "My Selected Subjects", text: "Build a personal subject list for quicker access and keep the selection locally and with your account." },
      { title: "FPSC syllabus screens", text: "Read each available subject syllabus and suggested readings in a dedicated, easy-to-scan layout." },
      { title: "Structured lectures", text: "Study book-like lessons with headings, evidence, bullets, tables and Pakistan-focused application." },
      { title: "Course resource hubs", text: "Open the available syllabus, lectures, solved papers, MCQs and reels from one subject page." },
      { title: "Language-aware learning", text: "Choose English or Urdu for relevant Islamiyat material and access Comparative Religions where applicable." },
      { title: "Resume and progress", text: "Continue from the last learning point instead of searching through a subject again." }
    ]
  },
  {
    id: "papers",
    shortLabel: "WRITE",
    title: "Solved CSS written past papers",
    summary: "Turn a large paper archive into a navigable answer-writing library.",
    features: [
      { title: "Subject-wise solved papers", text: "Browse written papers by compulsory subject, optional group, subject and year." },
      { title: "Question and part navigation", text: "Move from one part to the next question automatically when a question has no remaining parts." },
      { title: "Pinned paper subjects", text: "Keep frequently used subjects above the group catalogue while preserving their original group location." },
      { title: "Search and collapsible groups", text: "Find a paper quickly or keep only the groups you need open." },
      { title: "Reading resume", text: "Return to an in-progress paper and see where reading stopped." },
      { title: "Technical answer formatting", text: "Read equations, calculations, tables and code-style material in responsive paper layouts." },
      { title: "Written-paper focus", text: "Objective Question 1 sections are kept out of the solved written-paper reader." }
    ]
  },
  {
    id: "mcqs",
    shortLabel: "PRACTISE",
    title: "Past-paper and practice MCQs",
    summary: "Practise, pause, resume and understand performance instead of reading a static answer key.",
    features: [
      { title: "Past-paper MCQs", text: "Attempt available objective papers by CSS subject and year with visible question totals." },
      { title: "Practice MCQ banks", text: "Use dedicated practice sets for supported compulsory and optional subjects." },
      { title: "Timed attempts", text: "Train under a countdown that pauses when the attempt screen is left." },
      { title: "Saved attempt state", text: "Keep answered questions, selections, score state and remaining time after an interruption." },
      { title: "Scoring and accuracy", text: "Review performance by paper or subject and identify weaker knowledge areas." },
      { title: "Previous, next and reset", text: "Navigate long options comfortably, revisit questions and intentionally start a fresh attempt." },
      { title: "Clear corrections", text: "See the correct option after selection, with working retained for mathematical or technical questions." }
    ]
  },
  {
    id: "mpt",
    shortLabel: "TEST",
    title: "CSS MPT preparation and mock tests",
    summary: "Combine screening-test knowledge, full-length practice and interruption-safe attempts.",
    features: [
      { title: "MPT past papers", text: "Practise available FPSC MPT years in an interactive question flow." },
      { title: "Five full mock tests", text: "Attempt 200-question Mock Tests 1–5 built for broad and increasingly complex revision." },
      { title: "200-minute countdown", text: "Use a full-attempt timer with minutes and seconds moving backwards." },
      { title: "Pause and resume", text: "Switch apps or leave the screen without silently resetting the active attempt." },
      { title: "Results and review", text: "Finish a test, inspect the score and revisit errors before resetting." },
      { title: "Content-sensitive profiles", text: "Keep the standard MPT flow separate from the opt-in non-Muslim MPT course profile." }
    ]
  },
  {
    id: "english",
    shortLabel: "WORDS",
    title: "Vocabulary, English and language practice",
    summary: "Build usable language through meaning, context, recall and visual memory.",
    features: [
      { title: "Visual vocabulary cards", text: "Learn supported words with uncropped images designed as visual recall cues." },
      { title: "English and Urdu meanings", text: "Connect an English word with a clear meaning and relevant Urdu support." },
      { title: "Synonyms and sentences", text: "See readable synonyms and a contextual sentence instead of an isolated definition." },
      { title: "Vocabulary history", text: "Move through unseen, visited, previous and next words without repeatedly restarting." },
      { title: "English learning reels", text: "Revise idioms, pairs of words, groups of words and Urdu-to-English translations." },
      { title: "Interactive language questions", text: "Answer fill-in-the-blank and MCQ-style cards with immediate correction." }
    ]
  },
  {
    id: "current-affairs",
    shortLabel: "UPDATE",
    title: "Current affairs and weekly solutions",
    summary: "Connect fresh developments with the CSS syllabus and longer analytical revision.",
    features: [
      { title: "National and international news", text: "Read separate live streams for Pakistan and world developments." },
      { title: "Latest-first updates", text: "Prioritise newly fetched items, retain a short cache and fall back quietly when a source is unavailable." },
      { title: "Weekly current-affairs library", text: "Browse built-in 2026 weekly solutions with month and syllabus-scope filters." },
      { title: "CSS analytical structure", text: "Review facts, context, Pakistan impact, policy direction and answer-ready summaries." },
      { title: "Official-source links", text: "Open the original source when a current-affairs item includes one." },
      { title: "Offline reading fallback", text: "Keep bundled and cached material useful when the device has no stable connection." }
    ]
  },
  {
    id: "reels",
    shortLabel: "REVISE",
    title: "CSS study reels and course profiles",
    summary: "Use a social-style feed for focused learning—not random entertainment.",
    features: [
      { title: "Full-screen vertical feed", text: "Scroll one centred learning reel at a time through For You, Following and Saved views." },
      { title: "Balanced course rotation", text: "Mix compulsory and followed subjects so one course or one content type does not dominate the feed." },
      { title: "Unseen-first ordering", text: "Prioritise unviewed reels and recycle older material only after the relevant pool is completed." },
      { title: "Mixed learning formats", text: "Rotate lessons, facts, MCQs, vocabulary, images and current affairs across subjects." },
      { title: "Multi-card posts", text: "Swipe complete parts inside a reel, use clear progress dots and open a full-screen card reader." },
      { title: "Course profiles", text: "Follow subjects, inspect a course grid and open its reels directly with back navigation." },
      { title: "Like, save and viewed history", text: "Keep useful posts and filter saved or previously viewed reels from a course profile." },
      { title: "Image and memory optimisation", text: "Prefer downloaded images, fall back to remote files and limit rendering around the active reel." },
      { title: "Respectful audio controls", text: "Mute or unmute optional feed music while automatically blocking it on religious-content reels." }
    ]
  },
  {
    id: "offline-progress",
    shortLabel: "CONTINUE",
    title: "Offline study, progress and personal tools",
    summary: "Keep everyday study responsive first, then synchronize supported activity when a connection returns.",
    features: [
      { title: "Offline-first progress", text: "Write supported lesson, paper, MCQ, vocabulary and reel activity locally before waiting for a server." },
      { title: "Automatic synchronization", text: "Sync supported progress to the account when internet access becomes stable and avoid duplicate records." },
      { title: "Cross-device continuity", text: "Restore supported account progress on another device after signing in." },
      { title: "Persistent local history", text: "Keep supported study history on the device even after logout." },
      { title: "Personal notes", text: "Save selected study notes for quick revision." },
      { title: "Daily app-time tracking", text: "Record personal study time locally and synchronize it safely with the account." },
      { title: "Selected-subject shortcuts", text: "Open the learner's chosen subjects without repeatedly browsing every CSS group." }
    ]
  },
  {
    id: "account",
    shortLabel: "STAY READY",
    title: "Accounts, alerts and app continuity",
    summary: "Reduce friction around access, support, updates and returning to the right learning item.",
    features: [
      { title: "Google, Apple and email access", text: "Use supported fast sign-in choices, with clear fallback and WhatsApp support guidance." },
      { title: "Learning notifications", text: "Receive varied revision prompts designed to avoid repeatedly sending the same reel." },
      { title: "Direct reel opening", text: "Open a supported reel notification at the intended post instead of scrolling through the feed." },
      { title: "Android and iOS update prompts", text: "Detect platform-specific versions and open the correct app store when an update is available." },
      { title: "Access-status visibility", text: "See relevant account access dates and timely renewal reminders where applicable." },
      { title: "Account deletion and support", text: "Manage the account and reach support through the in-app help path." }
    ]
  }
];

export const appFeatureList = appFeatureGroups.flatMap((group) =>
  group.features.map((feature) => `${feature.title}: ${feature.text}`)
);

export const socialProfiles = {
  instagram: {
    name: "Instagram",
    handle: "@aspirant.com.pk",
    url: "https://www.instagram.com/aspirant.com.pk/"
  }
};

export const sourceLinks = [
  {
    name: "FPSC CSS section",
    url: "https://www.fpsc.gov.pk/",
    note: "CSS advertisements, syllabus, rules, results and online services."
  },
  {
    name: "PPSC Punjab",
    url: "https://ppsc.gop.pk/",
    note: "Punjab PMS jobs, exam schedules, syllabi, eligibility and results."
  }
];

export const calendarEvents = [
  {
    date: "2026-08-03",
    title: "MPT notice watch",
    tag: "FPSC",
    color: "blue",
    window: "Expected Aug-Sep 2026",
    note: "Check notice status. Prepare documents.",
    sourceName: "FPSC CSS section",
    sourceUrl: "https://www.fpsc.gov.pk/"
  },
  {
    date: "2026-09-07",
    title: "MPT application window",
    tag: "MPT",
    color: "green",
    window: "Expected Sep 2026",
    note: "Keep CNIC, photo, degree and domicile ready.",
    sourceName: "FPSC Apply Online",
    sourceUrl: "https://online.fpsc.gov.pk/"
  },
  {
    date: "2026-10-26",
    title: "MPT final revision",
    tag: "MPT",
    color: "gold",
    window: "Expected Oct-Nov 2026",
    note: "Timed MCQs, English, Pakistan affairs and GSA.",
    sourceName: "FPSC MPT/CSS rules",
    sourceUrl: "https://www.fpsc.gov.pk/"
  },
  {
    date: "2026-11-16",
    title: "Written prep shift",
    tag: "WRITE",
    color: "teal",
    window: "After MPT result phase",
    note: "Shift to essay, precis and optional answers.",
    sourceName: "FPSC CSS syllabus",
    sourceUrl: "https://www.fpsc.gov.pk/"
  },
  {
    date: "2027-02-01",
    title: "Written exam target",
    tag: "CSS",
    color: "red",
    window: "Expected Feb 2027",
    note: "Mocks, outlines and final revision.",
    sourceName: "FPSC CSS section",
    sourceUrl: "https://www.fpsc.gov.pk/"
  },
  {
    date: "2026-06-15",
    title: "PMS schedule check",
    tag: "PMS",
    color: "purple",
    window: "Weekly source check",
    note: "Open the PPSC schedule and PMS job notices.",
    sourceName: "PPSC schedule",
    sourceUrl: "https://ppsc.gop.pk/"
  }
];

export const compulsorySubjects = [
  { title: "English Essay", marks: 100, focus: "Argument, structure, clarity and evidence." },
  { title: "English Precis & Composition", marks: 100, focus: "Precis, comprehension, grammar and vocabulary." },
  { title: "General Science & Ability", marks: 100, focus: "Everyday science, ability, logic and quantitative basics." },
  { title: "Current Affairs", marks: 100, focus: "Pakistan, world affairs, economy, governance and policy issues." },
  { title: "Pakistan Affairs", marks: 100, focus: "History, constitution, society, geography and national issues." },
  { title: "Islamic Studies / Comparative Study of Major Religions", marks: 100, focus: "Conceptual, historical and contemporary religious themes." }
];

export const optionalSubjectGroups = [
  {
    group: "Group I",
    rule: "Select one subject of 200 marks.",
    subjects: ["Accountancy & Auditing", "Economics", "Computer Science", "Political Science", "International Relations"]
  },
  {
    group: "Group II",
    rule: "Select subject(s) carrying 200 marks.",
    subjects: ["Physics", "Chemistry", "Applied Mathematics", "Pure Mathematics", "Statistics", "Geology"]
  },
  {
    group: "Group III",
    rule: "Select one subject of 100 marks.",
    subjects: ["Business Administration", "Public Administration", "Governance & Public Policies", "Town Planning & Urban Management"]
  },
  {
    group: "Group IV",
    rule: "Select one subject of 100 marks.",
    subjects: ["History of Pakistan & India", "Islamic History & Culture", "British History", "European History", "History of USA"]
  },
  {
    group: "Group V",
    rule: "Select one subject of 100 marks.",
    subjects: ["Gender Studies", "Environmental Sciences", "Agriculture & Forestry", "Botany", "Zoology", "English Literature", "Urdu Literature"]
  },
  {
    group: "Group VI",
    rule: "Select one subject of 100 marks.",
    subjects: ["Law", "Constitutional Law", "International Law", "Muslim Law & Jurisprudence", "Mercantile Law", "Criminology", "Philosophy"]
  },
  {
    group: "Group VII",
    rule: "Select one subject of 100 marks.",
    subjects: ["Journalism & Mass Communication", "Psychology", "Geography", "Sociology", "Anthropology", "Punjabi", "Sindhi", "Pashto", "Balochi", "Persian", "Arabic"]
  }
];

export const syllabusSubjects = cssSyllabusCatalog.map((subject) => ({
  ...subject,
  path: `/css-${subject.id}-syllabus`
}));

const subjectSyllabusPages = Object.fromEntries(
  syllabusSubjects.map((subject) => {
    const relatedSubjects = syllabusSubjects
      .filter((candidate) =>
        candidate.id !== subject.id &&
        candidate.category === subject.category &&
        candidate.group === subject.group
      )
      .slice(0, 4)
      .map((candidate) => candidate.path);

    return [subject.path, {
      path: subject.path,
      kind: "subject-syllabus",
      subjectId: subject.id,
      title: `${subject.name} CSS Syllabus | FPSC Topics & Marks`,
      description: `Study the FPSC ${subject.name} CSS syllabus: ${subject.marks}-mark paper outline, prescribed topics and suggested readings. Check FPSC for changes before your exam year.`,
      category: "CSS subject syllabus",
      datePublished: "2026-09-26",
      dateModified: "2026-09-26",
      keywords: `CSS ${subject.name} syllabus, FPSC ${subject.name} syllabus, ${subject.name} CSS topics, CSS preparation Pakistan`,
      related: ["/css-syllabus", "/css-subjects", ...relatedSubjects],
      schemaKind: "webpage"
    }];
  })
);

export const eligibilityCriteria = [
  { label: "Education", value: "Bachelor’s degree with at least second division or equivalent qualification." },
  { label: "Age planning range", value: "Normally 21 to 30 years on the CSS cutoff date, with relaxations for eligible categories." },
  { label: "Attempts", value: "Maximum three CSS attempts." },
  { label: "Nationality", value: "Pakistani citizen with the required domicile details for quota and application processing." },
  { label: "Documents", value: "CNIC, domicile, degree/transcript, equivalence if needed, photo, fee proof and application print." }
];

export const navigation = [
  { label: "Home", path: "/" },
  { label: "Start Here", path: "/css-2027" },
  { label: "FPSC Syllabus", path: "/css-syllabus" },
  { label: "Subjects", path: "/css-subjects" },
  { label: "Past Papers", path: "/css-past-papers" },
  { label: "Answer Tips", path: "/answer-writing-tips" },
  { label: "MPT", path: "/mpt-2027" },
  { label: "PMS", path: "/pms-preparation" },
  { label: "Blogs", path: "/blogs" },
  { label: "Contact", path: "/contact" }
];

export const publicRoutes = [
  "/",
  "/css-2027",
  "/exam-calendar",
  "/css-eligibility",
  "/css-subjects",
  "/css-syllabus",
  "/css-past-papers",
  "/answer-writing-tips",
  "/mpt-past-papers",
  "/mpt-result-2026",
  "/mpt-2027",
  "/pms-preparation",
  "/study-plan",
  "/blogs",
  "/css-vista",
  "/about",
  "/contact",
  "/aspirant-app",
  "/privacy-policy",
  "/terms-of-use",
  "/sitemap",
  "/hk/dev"
];

const sourceCards = sourceLinks.map((source) => ({
  title: source.name,
  text: source.note,
  path: source.url
}));

const blogSpecs = [
  ["css-from-zero", "CSS from Zero: What to Understand First", "A beginner-friendly map of CSS exam stages, papers, MPT, optional subjects and the first study week.", "Start Here", ["CSS has screening, written papers, psychological assessment, interview and allocation.", "Begin with the exam structure before buying books.", "Your first week should be small enough to repeat."], ["Read the CSS structure once.", "Check eligibility.", "Open the compulsory subject list.", "Write one short paragraph daily."]],
  ["css-optional-subjects-selection", "How to Select CSS Optional Subjects", "A calm method for selecting CSS optional subjects using background, overlap, interest and revision time.", "Subjects", ["Do not select a subject only because someone calls it scoring.", "Background and revision capacity matter more than hype.", "Past papers reveal whether the paper suits you."], ["Shortlist subjects you understand.", "Check overlap with compulsory papers.", "Attempt one past-paper question.", "Finalize after comparing revision load."]],
  ["css-compulsory-subjects-guide", "CSS Compulsory Subjects Explained", "A simple explanation of the six compulsory CSS papers and how beginners should approach them.", "Subjects", ["Compulsory papers are the base everyone shares.", "English Essay and Precis need daily practice.", "Current Affairs connects with Pakistan Affairs and governance."], ["List all six compulsory papers.", "Start English writing from day one.", "Create one current affairs notebook.", "Revise Pakistan Affairs with timelines."]],
  ["css-mpt-beginner-guide", "CSS MPT Beginner Guide", "A beginner guide to CSS MPT preparation, MCQ practice, topic rotation and error logs.", "MPT", ["MPT is a screening test, not the full CSS written exam.", "Short timed MCQ sessions work better than random reading.", "An error log is more useful than a huge PDF folder."], ["Solve 25 MCQs daily.", "Mark every wrong answer.", "Revise mistakes after two days.", "Take one mixed mock weekly."]],
  ["css-first-week-study-plan", "Your First Week CSS Study Plan", "A practical first-week CSS timetable for beginners who do not know where to start.", "Study Plan", ["The first week should create rhythm, not pressure.", "Daily English is non-negotiable.", "Small blocks reduce confusion."], ["Day 1: understand CSS structure.", "Day 2: check eligibility.", "Day 3: read compulsory subjects.", "Day 4-7: English, current affairs and MCQs."]],
  ["css-essay-start", "How to Start CSS Essay Preparation", "A beginner CSS essay guide covering outlines, arguments, examples and daily writing practice.", "Writing", ["Essay preparation starts with thinking clearly.", "Outlines train structure before full essays.", "Examples should support arguments, not decorate them."], ["Write one outline daily.", "Collect examples under themes.", "Practice introductions twice a week.", "Review one past essay topic weekly."]],
  ["css-precis-composition", "CSS Precis and Composition for Beginners", "How beginners can start CSS precis, comprehension, grammar and vocabulary without getting overwhelmed.", "Writing", ["Precis rewards clarity and compression.", "Grammar improves through targeted correction.", "Vocabulary should be used in context."], ["Summarize one editorial paragraph.", "Review grammar mistakes.", "Learn 5 words with sentences.", "Practice comprehension weekly."]],
  ["current-affairs-for-css", "How to Study Current Affairs for CSS", "A simple current affairs system for CSS beginners using themes, notes and answer relevance.", "Current Affairs", ["Current affairs is not daily news hoarding.", "Themes matter more than headlines.", "Notes should become answer material."], ["Track economy, governance, foreign policy and climate.", "Write one-page briefs.", "Add facts and examples.", "Connect issues to Pakistan."]],
  ["pakistan-affairs-css", "Pakistan Affairs CSS Starter Guide", "A beginner guide to Pakistan Affairs topics, timelines, constitution, geography and current issues.", "Compulsory", ["Pakistan Affairs mixes history and current national issues.", "Timelines make revision easier.", "Constitutional developments appear across papers."], ["Build a timeline from 1857 onward.", "Study constitutional milestones.", "Create province-wise notes.", "Link history to present issues."]],
  ["general-science-ability-css", "General Science and Ability for CSS", "How to start General Science and Ability with everyday science, math basics and logical reasoning.", "Compulsory", ["GSA is manageable with topic rotation.", "Basic math and logic need practice, not reading only.", "Everyday science should be revised in small chunks."], ["Rotate science topics.", "Practice quantitative questions.", "Revise formulas weekly.", "Use MCQs for recall."]],
  ["islamic-studies-css", "Islamic Studies CSS Preparation Guide", "A balanced beginner guide for Islamic Studies and Comparative Study preparation in CSS.", "Compulsory", ["Conceptual clarity matters more than memorized paragraphs.", "Contemporary relevance improves answers.", "References should be accurate and relevant."], ["List recurring themes.", "Prepare short references.", "Connect concepts to modern issues.", "Practice structured answers."]],
  ["international-relations-css", "International Relations CSS Optional Guide", "How to decide whether International Relations is a good optional subject for CSS.", "Optionals", ["IR overlaps with Current Affairs.", "It needs conceptual frameworks and examples.", "Past papers test analysis, not only facts."], ["Read the syllabus.", "Check past paper themes.", "Test one question.", "Compare with Political Science."]],
  ["political-science-css", "Political Science CSS Optional Guide", "A beginner guide to Political Science as a CSS optional subject and who should choose it.", "Optionals", ["Political Science is theory-heavy.", "It overlaps with governance, constitutions and Pakistan Affairs.", "It rewards structured analytical answers."], ["Review political theory basics.", "Check constitutional topics.", "Attempt one past question.", "Compare revision size."]],
  ["computer-science-css", "Computer Science CSS Optional Guide", "A software-friendly guide to Computer Science optional for CSS aspirants from technical backgrounds.", "Optionals", ["Computer Science suits candidates with real CS background.", "Technical comfort does not remove answer-writing needs.", "Past papers should be checked before selecting it."], ["Compare syllabus with your degree.", "Check numerical and theory balance.", "Attempt past questions.", "Plan diagrams and definitions."]],
  ["gender-studies-css", "Gender Studies CSS Optional Guide", "How beginners can evaluate Gender Studies for CSS optional subject selection.", "Optionals", ["Gender Studies overlaps with society, policy and current affairs.", "It needs concepts plus Pakistani context.", "Examples and data improve answers."], ["Read key concepts.", "Collect Pakistan examples.", "Check past papers.", "Practice concise analytical answers."]],
  ["environmental-science-css", "Environmental Sciences CSS Optional Guide", "A beginner guide to Environmental Sciences for CSS optional subject selection.", "Optionals", ["Environmental Sciences overlaps with climate current affairs.", "Diagrams and examples can strengthen answers.", "Scientific basics should be clear."], ["Review climate themes.", "Learn diagrams.", "Collect Pakistan case studies.", "Practice one answer weekly."]],
  ["public-administration-css", "Public Administration CSS Optional Guide", "How to evaluate Public Administration for CSS optional subjects and governance overlap.", "Optionals", ["Public Administration overlaps with governance topics.", "It suits candidates comfortable with management and policy.", "Examples from Pakistan strengthen answers."], ["Review theories.", "Collect governance examples.", "Check past papers.", "Compare with Governance & Public Policies."]],
  ["law-css-optional", "Law CSS Optional Guide", "A beginner guide to choosing Law as a CSS optional subject.", "Optionals", ["Law suits candidates with legal background.", "Precision matters in legal answers.", "Bare-act familiarity helps."], ["Compare syllabus with your background.", "Read past papers.", "Check time required for revision.", "Practice issue-based answers."]],
  ["history-css-optionals", "History Optional Subjects in CSS", "How to compare History of USA, British History, European History and Indo-Pak history for CSS.", "Optionals", ["History subjects need timelines.", "Narrative plus analysis matters.", "Past-paper repetition can guide preparation."], ["Pick one history track.", "Build timelines.", "Practice causes and impacts.", "Revise maps and dates carefully."]],
  ["journalism-css", "Journalism and Mass Communication CSS Optional Guide", "A beginner guide to Journalism and Mass Communication for CSS optional selection.", "Optionals", ["Journalism overlaps with media and current affairs.", "Definitions and examples matter.", "Answers should connect theory with Pakistan media."], ["Read media theories.", "Collect local examples.", "Check past trends.", "Practice short notes."]],
  ["psychology-css", "Psychology CSS Optional Guide", "How beginners can decide whether Psychology is a suitable CSS optional subject.", "Optionals", ["Psychology needs concepts, theories and examples.", "Diagrams can help retention.", "Interest is important for revision."], ["Read basic schools of thought.", "Check past papers.", "Make theory cards.", "Practice applied examples."]],
  ["sociology-css", "Sociology CSS Optional Guide", "A beginner guide to Sociology as a CSS optional subject and its overlap with society topics.", "Optionals", ["Sociology connects with social issues and Pakistan Affairs.", "Conceptual definitions matter.", "Local examples improve answers."], ["Learn core concepts.", "Collect Pakistan social examples.", "Attempt one past question.", "Revise thinkers briefly."]],
  ["css-books-for-beginners", "CSS Books for Beginners: How to Choose", "How fresh CSS aspirants should choose books without creating a useless pile.", "Resources", ["More books do not mean better preparation.", "One main source per subject is enough at the start.", "Past papers should guide reading."], ["Pick one base book.", "Use syllabus as checklist.", "Add past papers early.", "Avoid collecting PDFs randomly."]],
  ["css-notes-system", "How to Make CSS Notes", "A practical CSS notes system for beginners using short sheets, examples, facts and revision blocks.", "Study System", ["Notes should reduce future work.", "Short sheets beat copied chapters.", "Revision design matters from day one."], ["Use one-page topic sheets.", "Add facts and examples.", "Keep definitions separate.", "Revise weekly."]],
  ["css-past-papers-method", "How to Use CSS Past Papers", "A beginner method for reading CSS past papers before and during preparation.", "Past Papers", ["Past papers show examiner style.", "They prevent blind reading.", "They should be used before syllabus completion too."], ["Read five years of questions.", "Mark repeated themes.", "Write rough outlines.", "Compare with syllabus."]],
  ["css-timetable-mistakes", "CSS Timetable Mistakes Beginners Make", "Common CSS timetable mistakes and a simpler way to plan a week.", "Study Plan", ["Huge timetables often fail.", "A repeatable week matters more than a perfect chart.", "Testing must be included."], ["Plan fewer blocks.", "Keep English daily.", "Add revision time.", "Review every Sunday."]],
  ["css-answer-writing", "CSS Answer Writing for Beginners", "How to start CSS answer writing with structure, headings, arguments and examples.", "Writing", ["Answer writing is a skill, not handwriting decoration.", "Structure helps the examiner follow your point.", "Examples should be relevant."], ["Write introductions.", "Use headings.", "Add examples.", "Review with past-paper demands."]],
  ["css-interview-overview", "CSS Interview and Viva Overview", "A simple overview of CSS interview preparation for aspirants planning the full journey.", "Interview", ["Interview preparation starts with awareness, not panic.", "Personality, knowledge and clarity matter.", "Written preparation also builds interview material."], ["Track your optional subjects.", "Understand your background.", "Read national issues.", "Practice concise answers."]],
  ["pms-vs-css", "CSS vs PMS: Beginner Difference", "A beginner comparison of CSS and PMS for Pakistani candidates deciding where to focus.", "PMS", ["CSS is federal, PMS is provincial.", "Syllabi and schedules differ.", "Preparation overlaps but applications differ."], ["Compare eligibility.", "Check syllabus differences.", "Track PPSC schedule.", "Use overlap smartly."]],
  ["css-mistakes-first-time", "30 CSS Beginner Mistakes to Avoid", "A practical list of common mistakes first-time CSS aspirants should avoid.", "Start Here", ["Starting without structure wastes time.", "Subject selection should not be emotional.", "Writing practice cannot be delayed."], ["Avoid book collecting.", "Avoid random optional selection.", "Avoid ignoring English.", "Avoid skipping past papers."]]
];

const blogBriefs = {
  "css-from-zero": {
    angle: "Start with the shape of the exam before choosing books, teachers or optional subjects.",
    mistake: "Beginners often treat CSS as a pile of subjects instead of a sequence of decisions.",
    practice: "Build a one-page exam map: MPT, written papers, psychological assessment, interview and allocation."
  },
  "css-optional-subjects-selection": {
    angle: "Subject selection is a risk-management decision, not a popularity contest.",
    mistake: "The phrase “scoring subject” becomes dangerous when it ignores background, overlap and revision load.",
    practice: "Score each optional subject against comfort, syllabus size, past-paper style and overlap."
  },
  "css-compulsory-subjects-guide": {
    angle: "Compulsory papers are the foundation of the written exam and should be understood before optionals.",
    mistake: "Many students delay English and Current Affairs while chasing optional shortcuts.",
    practice: "Create six folders: Essay, Precis, GSA, Current Affairs, Pakistan Affairs and Islamic Studies."
  },
  "css-mpt-beginner-guide": {
    angle: "MPT preparation is about recall, accuracy and speed before the written race begins.",
    mistake: "Random MCQs without an error log make the same weak areas repeat every week.",
    practice: "Use small timed MCQ blocks and review wrong answers after 48 hours."
  },
  "css-first-week-study-plan": {
    angle: "The first week should create rhythm and confidence, not a perfect timetable.",
    mistake: "A 12-hour timetable usually collapses before the student understands the exam.",
    practice: "Use four repeatable blocks: English, one issue, MCQs and revision."
  },
  "css-essay-start": {
    angle: "Essay preparation begins with arguments, outlines and examples before full-length attempts.",
    mistake: "Writing long essays without a clear thesis trains volume, not quality.",
    practice: "Draft outlines around governance, economy, education, climate and technology themes."
  },
  "css-precis-composition": {
    angle: "Precis and composition improves through correction loops, not passive grammar reading.",
    mistake: "Students memorize rules but never compress paragraphs under time.",
    practice: "Summarize one editorial paragraph, then rewrite it in half the words."
  },
  "current-affairs-for-css": {
    angle: "Current Affairs is a theme-based answer bank, not a newspaper archive.",
    mistake: "Saving every headline creates noise and weakens recall.",
    practice: "Track economy, governance, foreign policy, climate, security and technology as recurring themes."
  },
  "pakistan-affairs-css": {
    angle: "Pakistan Affairs links history, constitution, geography, society and current governance.",
    mistake: "Memorized timelines alone cannot answer analytical questions.",
    practice: "Connect each historical event with its institutional or political consequence."
  },
  "general-science-ability-css": {
    angle: "GSA becomes manageable when everyday science and ability practice rotate weekly.",
    mistake: "Reading science notes without solving ability questions leaves the paper half-prepared.",
    practice: "Mix science recall, basic math, logic and data interpretation in short sessions."
  },
  "islamic-studies-css": {
    angle: "Islamic Studies rewards conceptual clarity, balanced references and contemporary relevance.",
    mistake: "Overloaded quotations can weaken answers if the argument is unclear.",
    practice: "Prepare short frameworks for rights, governance, ethics, society and modern challenges."
  },
  "international-relations-css": {
    angle: "IR suits students who can combine theory, world affairs and analytical examples.",
    mistake: "Reading news without theory makes IR answers descriptive.",
    practice: "Pair each concept with one current example and one Pakistan angle."
  },
  "political-science-css": {
    angle: "Political Science is strong for students comfortable with theory, constitutions and institutions.",
    mistake: "Students underestimate the revision load of thinkers and constitutional comparison.",
    practice: "Prepare theory cards and compare political systems through short tables."
  },
  "computer-science-css": {
    angle: "Computer Science can be efficient for real CS backgrounds but still needs CSS-style answers.",
    mistake: "Technical confidence can hide weak definitions, diagrams and paper presentation.",
    practice: "Turn each technical topic into definitions, diagrams, examples and past-paper outlines."
  },
  "gender-studies-css": {
    angle: "Gender Studies works when concepts are tied to Pakistani society, policy and evidence.",
    mistake: "Generic social commentary is not enough for high-quality answers.",
    practice: "Maintain examples on education, work, law, health, media and representation."
  },
  "environmental-science-css": {
    angle: "Environmental Sciences overlaps with climate, disaster management and Pakistan’s development issues.",
    mistake: "Ignoring diagrams and local case studies makes answers flat.",
    practice: "Prepare diagrams for cycles, pollution, climate systems and environmental governance."
  },
  "public-administration-css": {
    angle: "Public Administration connects management theory with Pakistani governance problems.",
    mistake: "Theory without examples becomes abstract and forgettable.",
    practice: "Link each concept with service delivery, accountability, budgeting or local government."
  },
  "law-css-optional": {
    angle: "Law is best for candidates who can handle precise concepts, provisions and issue-based reasoning.",
    mistake: "Choosing Law without background can consume revision time fast.",
    practice: "Practice issue-rule-application-conclusion style answers."
  },
  "history-css-optionals": {
    angle: "History optionals require timelines plus cause-effect analysis.",
    mistake: "Dates without interpretation do not produce strong answers.",
    practice: "Build event chains: background, causes, actors, consequences and relevance."
  },
  "journalism-css": {
    angle: "Journalism and Mass Communication links theory, media systems, ethics and Pakistan examples.",
    mistake: "Students write opinions instead of using media concepts.",
    practice: "Prepare theories, digital media examples, regulation and media ethics cases."
  },
  "psychology-css": {
    angle: "Psychology is suitable when theories, diagrams and applications feel interesting to revise.",
    mistake: "Memorizing names without examples makes answers weak.",
    practice: "Pair each theory with an experiment, application and simple diagram."
  },
  "sociology-css": {
    angle: "Sociology helps students explain social problems through concepts and Pakistani examples.",
    mistake: "Common-sense answers without sociological vocabulary score poorly.",
    practice: "Use concepts like socialization, institutions, stratification and change."
  },
  "css-books-for-beginners": {
    angle: "Book selection should simplify preparation, not become a collection hobby.",
    mistake: "Too many sources create guilt and destroy revision.",
    practice: "Pick one base source, one past-paper file and one short notes system per subject."
  },
  "css-notes-system": {
    angle: "Good notes are a revision machine, not copied chapters.",
    mistake: "Long copied notes feel productive but are hard to revise before exams.",
    practice: "Create one-page sheets with definitions, facts, examples, diagrams and answer angles."
  },
  "css-past-papers-method": {
    angle: "Past papers reveal the examiner’s demand before the syllabus feels complete.",
    mistake: "Waiting until the end to open past papers creates blind preparation.",
    practice: "Mark repeated themes, command words and paper style before deep reading."
  },
  "css-timetable-mistakes": {
    angle: "A good timetable survives a normal week with distractions and low-energy days.",
    mistake: "Overloaded plans collapse and make students think they lack discipline.",
    practice: "Use anchor habits: daily English, daily recall, weekly mock and Sunday review."
  },
  "css-answer-writing": {
    angle: "Answer writing is the bridge between knowledge and marks.",
    mistake: "Students read for months but cannot structure a 20-mark response.",
    practice: "Write introductions, headings, mini-arguments and conclusions under time."
  },
  "css-interview-overview": {
    angle: "Interview preparation begins with self-awareness and national-issue clarity.",
    mistake: "Waiting until written result to understand your profile creates pressure.",
    practice: "Keep a profile notebook: education, district, optional subjects and public issues."
  },
  "pms-vs-css": {
    angle: "CSS and PMS overlap in preparation but differ in authority, schedule and application process.",
    mistake: "Students use one plan for both without tracking provincial requirements.",
    practice: "Maintain separate checklists for FPSC CSS and PPSC PMS updates."
  },
  "css-mistakes-first-time": {
    angle: "Most beginner mistakes are predictable and preventable with a clear system.",
    mistake: "Confusion feels like hard work when there is no order.",
    practice: "Avoid random books, random subjects, delayed English and late past-paper practice."
  }
};

const categoryFocus = {
  "Start Here": ["Exam map", "Eligibility", "First week", "Past papers"],
  Subjects: ["Syllabus fit", "Overlap", "Revision load", "Past-paper style"],
  MPT: ["MCQs", "Recall", "Error log", "Timed mock"],
  "Study Plan": ["Weekly rhythm", "Daily English", "Revision", "Mock review"],
  Writing: ["Structure", "Argument", "Examples", "Timed practice"],
  "Current Affairs": ["Themes", "Facts", "Pakistan angle", "Answer use"],
  Compulsory: ["Core concepts", "Past papers", "Notes", "Revision"],
  Optionals: ["Background fit", "Syllabus size", "Analytical style", "Scoring risk"],
  Resources: ["Syllabus", "Base source", "Past papers", "Revision"],
  "Study System": ["Short notes", "Recall", "Examples", "Weekly review"],
  "Past Papers": ["Themes", "Command words", "Outlines", "Repetition"],
  Interview: ["Profile", "National issues", "Clarity", "Confidence"],
  PMS: ["FPSC vs PPSC", "Eligibility", "Schedule", "Overlap"]
};

const categoryGuidance = {
  "Start Here": {
    demand:
      "A beginner guide should reduce the exam into decisions that can be completed in order: understand the stages, confirm eligibility, read the syllabus, inspect past papers and only then select sources.",
    evidence: [
      "Keep the current FPSC rules and syllabus beside your plan.",
      "Separate MPT screening from the 1,200-mark written examination.",
      "Record compulsory papers and optional groups on one page.",
      "Use recent past papers to test whether your plan matches examiner demand."
    ],
    assessment:
      "Progress is visible when you can explain the exam structure without notes, identify your next application milestone and produce a realistic first-week timetable."
  },
  Subjects: {
    demand:
      "Subject decisions must satisfy FPSC grouping rules while remaining realistic for your academic background, reading speed, answer-writing ability and revision time.",
    evidence: [
      "Compare the official syllabus line by line instead of relying on subject popularity.",
      "Read at least five recent papers to identify conceptual, factual and analytical demands.",
      "Map overlap with Current Affairs, Pakistan Affairs, Essay and other optionals.",
      "Estimate how many concise revision sheets the subject will require."
    ],
    assessment:
      "A subject is a sensible choice when you can understand its past-paper language, locate dependable sources and revise its core themes repeatedly before the examination."
  },
  MPT: {
    demand:
      "MPT preparation rewards accurate recall under time pressure. Reading must therefore lead to timed questions, error classification and repeated correction rather than passive completion of notes.",
    evidence: [
      "Separate errors caused by missing knowledge from errors caused by haste or misreading.",
      "Practise English, general ability, general knowledge and subject areas in rotation.",
      "Reattempt incorrect questions after a gap instead of immediately memorising an option letter.",
      "Use full mocks to test pacing only after short-topic accuracy improves."
    ],
    assessment:
      "Track accuracy by topic, average time per question and repeated mistakes. A rising score without a shrinking error log is not reliable progress."
  },
  "Study Plan": {
    demand:
      "A useful CSS timetable must survive ordinary days, missed sessions and changing energy levels. It should protect daily English while rotating knowledge, practice and revision.",
    evidence: [
      "Assign each study block a visible output such as an outline, précis, MCQ set or revision sheet.",
      "Keep buffer time for unfinished work instead of moving every missed task forward.",
      "Review the week using completed outputs, not estimated study hours.",
      "Schedule spaced revision before adding another source or topic."
    ],
    assessment:
      "The plan is working when essential tasks repeat consistently and weak areas receive more practice without making the whole timetable collapse."
  },
  Writing: {
    demand:
      "CSS writing is judged through relevance, structure, argument, language control and evidence. Reading helps only when candidates regularly convert knowledge into outlines and timed responses.",
    evidence: [
      "Identify the command word and exact scope before drafting an answer.",
      "Use a clear thesis, purposeful headings and connected paragraphs.",
      "Support claims with appropriate examples, facts, constitutional references or cases.",
      "Edit for grammar, repetition, unsupported claims and weak transitions."
    ],
    assessment:
      "Improvement appears in clearer outlines, fewer language errors, stronger evidence placement and the ability to finish within the available time."
  },
  "Current Affairs": {
    demand:
      "Current Affairs preparation should turn changing events into durable issue files covering background, stakeholders, verified data, Pakistan's position, competing views and realistic policy options.",
    evidence: [
      "Organise notes under the FPSC syllabus rather than newspaper dates.",
      "Record the source and date beside statistics that can change.",
      "Separate a reported event from the larger issue it illustrates.",
      "Update old issue briefs instead of creating a new file for every headline."
    ],
    assessment:
      "You are ready when a current development can be explained historically, analysed from more than one perspective and used in a structured CSS answer."
  },
  Compulsory: {
    demand:
      "Compulsory subjects require broad coverage, repeated writing and careful use of the official syllabus. They cannot be postponed while optional subjects receive all available time.",
    evidence: [
      "Convert every syllabus heading into a checklist of concepts and past questions.",
      "Maintain separate evidence banks for facts, examples, references and diagrams.",
      "Practise introductions, outlines and short responses before full answers.",
      "Review recurring themes across at least five years of papers."
    ],
    assessment:
      "A prepared topic should be explainable, supportable with accurate evidence and usable in a timed answer without reopening several books."
  },
  Optionals: {
    demand:
      "Optional preparation must balance conceptual coverage with scoring opportunities such as analytical comparison, relevant examples, diagrams, thinkers, cases or technical working.",
    evidence: [
      "Follow the FPSC syllabus rather than a publisher's chapter order.",
      "Identify recurring themes and changing question styles in recent papers.",
      "Build a compact terminology bank for accurate subject language.",
      "Prepare examples connected to Pakistan wherever the paper allows."
    ],
    assessment:
      "Readiness means you can outline unfamiliar questions by combining core concepts with relevant evidence instead of reproducing memorised notes."
  },
  Resources: {
    demand:
      "Resource selection should produce one dependable learning path per topic. Extra books are useful only when they fill a specific gap that the base source cannot answer.",
    evidence: [
      "Start from the official syllabus and recent past papers.",
      "Choose one base source and note exactly what it covers.",
      "Use reports, laws or official data only where they strengthen an examinable theme.",
      "Record publication dates for sources containing changeable facts."
    ],
    assessment:
      "A resource system is efficient when revision becomes shorter over time and every saved source has a clear purpose in an answer or concept."
  },
  "Study System": {
    demand:
      "A study system should make recall, correction and revision easier. Notes are valuable when they shorten future work and expose missing understanding.",
    evidence: [
      "Use concise topic sheets with definitions, arguments, evidence and likely questions.",
      "Keep mistakes and corrections beside the topic that produced them.",
      "Review from memory before rereading the sheet.",
      "Archive outdated facts rather than mixing them with current evidence."
    ],
    assessment:
      "The system is improving when you can rebuild an answer from a short sheet, identify weak points quickly and revise more topics in less time."
  },
  "Past Papers": {
    demand:
      "Past papers reveal examiner language, recurring themes and the depth expected from candidates. They should guide preparation from the beginning rather than remain a final-month activity.",
    evidence: [
      "Group questions by syllabus theme instead of year alone.",
      "Underline command words such as analyse, evaluate, compare and discuss.",
      "Draft outlines before reading solved answers.",
      "Record themes that recur with a different angle or contemporary context."
    ],
    assessment:
      "Useful past-paper practice produces stronger outlines, faster interpretation and clearer identification of the evidence each question requires."
  },
  Interview: {
    demand:
      "The CSS interview tests clarity, judgement, awareness and the ability to defend a position calmly. Preparation begins with an honest understanding of your own profile.",
    evidence: [
      "Prepare education, employment, domicile, interests and optional-subject decisions.",
      "Follow national and international issues from reliable sources.",
      "Practise concise answers that acknowledge uncertainty when necessary.",
      "Review the reasoning behind preferences rather than memorising slogans."
    ],
    assessment:
      "Progress appears when answers become shorter, better reasoned and more consistent under follow-up questions."
  },
  PMS: {
    demand:
      "PMS planning must follow the relevant provincial commission because schedules, eligibility, papers and optional combinations can differ from FPSC CSS.",
    evidence: [
      "Keep PPSC notices separate from FPSC CSS notices.",
      "Map overlapping subjects but maintain separate paper checklists.",
      "Verify domicile, age, attempts and documents from the current advertisement.",
      "Adjust revision around the actual provincial schedule once announced."
    ],
    assessment:
      "A combined CSS and PMS plan works when shared topics save time without causing you to miss province-specific requirements."
  }
};

function scoreFromSlug(slug, seed) {
  const total = slug.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return 54 + ((total + seed * 17) % 37);
}

function buildBlogSections({ slug, title, category, takeaways, steps }) {
  const brief = blogBriefs[slug];
  const focus = categoryFocus[category] || categoryFocus["Start Here"];
  const guidance = categoryGuidance[category] || categoryGuidance["Start Here"];
  const topic = title.replace(/^How to /, "").replace(/:.*$/, "").replace(/ Guide$/, "");

  return [
    {
      title: `${topic}: begin with the exam purpose`,
      body: [
        `${brief.angle} This is the starting point because CSS preparation becomes inefficient when a topic is studied without knowing where it appears in the syllabus, how it is tested and what output the examiner expects.`,
        `${takeaways[0]} ${takeaways[1]} Together, these points define what should be understood before adding books, videos or lengthy notes.`
      ],
      bullets: takeaways
    },
    {
      title: `What candidates misunderstand about ${topic.toLowerCase()}`,
      body: [
        `${brief.mistake} The result is usually fragmented preparation: candidates collect material but cannot explain which syllabus point it covers or how it will improve an answer.`,
        guidance.demand
      ],
      bullets: focus.map((item, index) => `${item}: ${takeaways[index % takeaways.length]}`)
    },
    {
      title: `Evidence and material to prepare for ${topic.toLowerCase()}`,
      body: [
        "Do not treat evidence as decoration added after an answer is written. Build it beside the concept so that facts, examples and references support a precise argument.",
        `For this ${category.toLowerCase()} area, use the following evidence checklist and verify changeable information before revision.`
      ],
      bullets: guidance.evidence
    },
    {
      title: `A practical method for ${topic.toLowerCase()}`,
      body: [
        `${brief.practice} Convert this into a repeatable sequence: learn one bounded concept, close the source, reproduce the main points, practise an exam-style output and correct it against the syllabus.`,
        "Keep the first attempt small. An outline, short calculation, MCQ set, précis paragraph or evidence sheet gives more diagnostic information than another hour of passive reading.",
        "Finish each session with a quality check: identify what you recalled correctly, what remained vague, which claim still needs evidence and what must be practised next. This turns study time into a visible improvement loop instead of an unmeasured reading routine."
      ],
      steps
    },
    {
      title: `Apply ${topic.toLowerCase()} through past-paper thinking`,
      body: [
        guidance.assessment,
        `Choose one relevant past question and identify its command word, boundaries and evidence needs. Draft the structure before checking notes. Then mark what was missing under four labels: concept, evidence, organization and expression.`
      ],
      bullets: [
        `Explain ${focus[0].toLowerCase()} without reopening the source.`,
        `Connect ${focus[1].toLowerCase()} with one recent or Pakistan-relevant example.`,
        `Produce one timed output focused on ${focus[2].toLowerCase()}.`,
        `Review the result through ${focus[3].toLowerCase()}.`
      ]
    },
    {
      title: `Seven-day revision check for ${topic.toLowerCase()}`,
      body: [
        "Use a short cycle instead of waiting for syllabus completion. On the first day, learn and reduce the topic. On the second, recall it without notes. Later in the week, practise it under a question and finish with correction.",
        "At the end of seven days, keep only the material that helped recall or answer construction. Move unresolved points into a clearly named weak-area list for the next cycle."
      ],
      steps: [
        `Day 1: ${steps[0]}`,
        `Day 2: recall the central concepts and correct omissions.`,
        `Day 3: ${steps[1] || steps[0]}`,
        `Day 4: attach one verified example or reference.`,
        `Day 5: ${steps[2] || "attempt a relevant past-paper outline."}`,
        `Day 6: ${steps[3] || "revise the corrected output."}`,
        "Day 7: test recall and schedule the next revision date."
      ]
    }
  ];
}

function buildBlogFaq({ slug, title, category }) {
  const brief = blogBriefs[slug];
  const guidance = categoryGuidance[category] || categoryGuidance["Start Here"];
  const topic = title.replace(/^How to /, "").replace(/:.*$/, "").replace(/ Guide$/, "").toLowerCase();
  return [
    {
      question: `Is ${title.replace("CSS ", "").replace(" Guide", "").toLowerCase()} important for CSS beginners?`,
      answer: `Yes. ${brief.angle} A beginner does not need to master everything immediately, but should understand the topic's syllabus position, exam use and first practice output.`
    },
    {
      question: `How can I measure improvement in ${topic}?`,
      answer: guidance.assessment
    },
    {
      question: "Which source should I trust for official dates and rules?",
      answer: "Use FPSC for CSS and MPT official notices, rules and syllabus. Use PPSC for Punjab PMS jobs, syllabi, schedules and results."
    }
  ];
}

const generatedBlogPosts = blogSpecs.map(([slug, title, description, category, takeaways, steps], index) => {
  const focus = categoryFocus[category] || categoryFocus["Start Here"];
  const chart = focus.map((label, chartIndex) => ({
    label,
    value: scoreFromSlug(slug, chartIndex),
    helper: chartIndex === 0 ? "Start here" : chartIndex === 1 ? "Build next" : chartIndex === 2 ? "Review weekly" : "Test it"
  }));
  const sourceReminder = category === "PMS" ? sourceLinks : [sourceLinks[0], sourceLinks[1]];

  return {
    slug,
    path: `/blog/${slug}`,
    title,
    description,
    category,
    readingTime: "10 min read",
    datePublished: "2026-06-15",
    dateModified: "2026-08-26",
    keywords: [
      title.toLowerCase(),
      `${category.toLowerCase()} CSS guide`,
      "CSS preparation Pakistan",
      "CSS beginner guide",
      "CSS 2027",
      "FPSC CSS syllabus",
      "CSS study plan",
      "Aspirant CSS"
    ].join(", "),
    tags: [
      category,
      "CSS preparation",
      "CSS 2027",
      "CSS beginner guide",
      "FPSC CSS",
      "Aspirant CSS"
    ],
    takeaways,
    steps,
    sections: buildBlogSections({ slug, title, category, takeaways, steps }),
    chart,
    checklist: [
      ...steps,
      "Save official FPSC/PPSC source links before acting on dates.",
      "Add one measurable output to your Aspirant progress tracker."
    ],
    matrix: focus.map((item, matrixIndex) => ({
      label: item,
      read: matrixIndex < 2 ? "High" : "Medium",
      practice: matrixIndex === 0 ? "Daily" : matrixIndex === 1 ? "3x weekly" : "Weekly",
      evidence: matrixIndex === 3 ? "Mock / past paper" : "Notes + correction"
    })),
    faq: buildBlogFaq({ slug, title, category }),
    sourceReminder,
    relatedGuides: ["/css-2027", "/css-subjects", "/study-plan", "/exam-calendar"],
    order: index + 1
  };
});

const featurePostSpecs = [
  {
    slug: "aspirant-solved-css-past-papers-app",
    title: "CSS Solved Past Papers App for Pakistan",
    description: "See how Aspirant organizes solved CSS written papers by subject, year, question and answer section on Android and iPhone.",
    category: "App Features",
    type: "solved-papers",
    heading: "Preview a solved paper before downloading",
    summary: "Open a subject, choose a year and move through structured question parts without searching across disconnected files.",
    takeaways: ["Browse papers by CSS group, subject and year.", "Resume the answer section you were reading.", "Read formulas, tables and long answers in mobile-friendly layouts."],
    steps: ["Choose a CSS subject.", "Open a solved year.", "Read the outline before the full answer.", "Continue from the saved reading point."],
    sections: [
      { title: "Why a solved-paper library is different from a PDF folder", body: ["A folder tells you that a file exists. A preparation library helps you find the exact subject, year, question and part that you need. Aspirant separates the paper catalogue from the answer reader so candidates can move directly from selection to study.", "The reader organizes long answers into readable sections and supports technical material such as equations, tables and code-style working where the paper requires it."], bullets: ["Group-wise subject catalogue", "Pinned subjects for faster access", "Question-to-question navigation", "Offline reading after content is available"] },
      { title: "Use solved answers without becoming dependent on them", body: ["Read the question first and draft a short outline before opening the solution. Then compare argument order, evidence placement and conclusion—not just wording.", "A solved answer is most useful when it exposes what your own attempt missed. Save those gaps as revision targets and return to the original question later."], steps: ["Read the command word.", "Draft three to five headings.", "Open the structured answer.", "Record one correction for the next attempt."] },
      { title: "Who benefits from this feature", body: ["It suits beginners learning answer structure, repeat candidates reviewing paper trends and working aspirants who need to study one question in a short session."], bullets: ["CSS compulsory and optional paper review", "Subject-wise year comparison", "Focused answer-writing practice", "Technical-paper revision on smaller screens"] }
    ]
  },
  {
    slug: "css-past-paper-mcqs-app",
    title: "CSS Past Paper MCQs App with Answers",
    description: "Practise CSS past-paper MCQs by subject and year, review correct answers, resume attempts and track accuracy in the Aspirant app.",
    category: "App Features",
    type: "mcqs",
    heading: "Try the MCQ interaction",
    summary: "The app turns a static answer list into a resumable practice session with scoring, previous-question navigation and reset controls.",
    takeaways: ["Filter MCQs by subject and year.", "Resume unfinished sessions after leaving the screen.", "Use accuracy signals to identify weak areas."],
    steps: ["Select a paper or all available years.", "Attempt without checking the answer first.", "Review the correction.", "Reset only when you want a fresh attempt."],
    sections: [
      { title: "Past-paper MCQs should diagnose knowledge", body: ["A score alone does not explain why an option was wrong. Aspirant keeps the question, selected option, correct option and session progress together so the attempt remains useful after the test ends.", "Subject and year filters help candidates separate a weak topic from a generally weak score."], bullets: ["Subject and year control", "Timed attempts", "Previous and next navigation", "Resume and reset actions"] },
      { title: "A simple correction cycle", body: ["Answer first, check the correction and revisit the same concept after a gap. Repeatedly reading the highlighted answer can create familiarity without recall.", "Use the result screen to decide what needs reading, what needs another MCQ set and what was only a careless mistake."], steps: ["Attempt a bounded set.", "Classify wrong answers.", "Revise the underlying concept.", "Reattempt later instead of immediately."] },
      { title: "Designed for short and full sessions", body: ["A candidate can practise one year, combine available papers or leave midway and continue later. Local progress keeps the flow useful even when connectivity changes."], bullets: ["Quick daily practice", "Full-paper revision", "Topic weakness detection", "Offline-first attempt history"] }
    ]
  },
  {
    slug: "css-vocabulary-builder-app",
    title: "CSS Vocabulary App with Urdu Meanings",
    description: "Learn CSS vocabulary through images, Urdu meanings, synonyms, sentences and saved progress in the Aspirant Android and iPhone app.",
    category: "App Features",
    type: "vocabulary",
    heading: "See how one vocabulary card works",
    summary: "Each card connects the word with meaning, context and recall instead of presenting an isolated dictionary entry.",
    takeaways: ["Learn through English and easy Urdu meaning.", "Connect words with synonyms, sentences and visuals.", "Continue from visited vocabulary instead of restarting."],
    steps: ["Read the word aloud.", "Predict the meaning.", "Reveal the detailed card.", "Use the word in your own sentence."],
    sections: [
      { title: "Why context matters for CSS vocabulary", body: ["Words become usable when candidates understand tone, meaning and sentence position. A translation alone may help recognition but not essay, précis or comprehension writing.", "Aspirant combines the word with Urdu meaning, synonyms and a sentence so the learner can connect recognition with actual use."], bullets: ["Easy Urdu meaning", "Context sentence", "Synonym support", "Visual memory cue"] },
      { title: "A better five-word routine", body: ["Learn fewer words with stronger recall. Predict before revealing, say the meaning without looking and write one sentence that would fit formal CSS writing.", "Use Previous to revisit the actual word you saw rather than increasing a counter through repeated navigation."], steps: ["Preview five unseen words.", "Recall without the detailed card.", "Write two original sentences.", "Review the weakest word tomorrow."] },
      { title: "Progress that survives interruptions", body: ["Visited words, saved state and history are retained locally for fast access. Signed-in users can also carry synchronized progress without making the study screen wait for the network."], bullets: ["Offline access", "Visited-word count", "Previous and next history", "Background synchronization"] }
    ]
  },
  {
    slug: "css-mpt-mock-tests-app",
    title: "CSS MPT Mock Test App: 200 Questions",
    description: "Prepare for CSS MPT with timed 200-question mock tests, past-paper practice, scoring and offline resume in the Aspirant app.",
    category: "App Features",
    type: "mpt-mocks",
    heading: "Preview the MPT test flow",
    summary: "Mocks combine a realistic question load with a timer, saved attempt and clear progress so an interrupted session does not become a lost session.",
    takeaways: ["Attempt full 200-question MPT mocks.", "Pause naturally when leaving the test screen.", "Resume or reset an attempt with control."],
    steps: ["Choose a mock or past MPT year.", "Start the timed attempt.", "Use Previous when reviewing a question.", "Finish and inspect the score."],
    sections: [
      { title: "A mock should train decisions under time", body: ["The purpose of a mock is not only to display 200 questions. It should reveal pacing, uncertainty and the topics that consume too much time.", "Aspirant keeps the countdown, answered count and saved question position together during the attempt."], bullets: ["200-minute countdown", "Question progress", "Previous-question control", "Resume after interruption"] },
      { title: "Use scores as a revision map", body: ["Separate missing knowledge from misreading and rushing. A low score in one section requires different work from scattered careless errors.", "Restart only after reviewing the previous attempt; otherwise a fresh score hides the same unresolved weaknesses."], steps: ["Complete one bounded attempt.", "Review incorrect concepts.", "Revise the weakest section.", "Schedule the next mock after correction."] },
      { title: "Practice can continue offline", body: ["Mock and past-paper progress is written locally first. When a signed-in user later has a stable connection, synchronization can happen without blocking the question interface."], bullets: ["Offline attempts", "Local resume", "Saved score state", "Quiet online synchronization"] }
    ]
  },
  {
    slug: "css-study-reels-app",
    title: "CSS Study Reels App for Daily Revision",
    description: "Explore short study reels built from CSS lessons, MCQs, vocabulary and current affairs—with unseen-first course rotation in Aspirant.",
    category: "App Features",
    type: "reels",
    heading: "Preview a focused study feed",
    summary: "The feed turns existing learning material into compact, swipeable cards while preserving course identity, saved posts and viewed history.",
    takeaways: ["See one focused learning point at a time.", "Rotate across courses instead of repeating one subject.", "Save posts and open course profiles."],
    steps: ["Follow useful course profiles.", "Read or answer the active card.", "Swipe within multi-card posts.", "Save material worth revising."],
    sections: [
      { title: "A study feed should still feel like preparation", body: ["Aspirant reels are not random entertainment clips. Cards are built from lessons, verified MCQs, vocabulary and current-affairs material so every scroll has a defined learning purpose.", "Course rotation and unseen-first ordering reduce immediate repetition while viewed and saved history remains available from profiles."], bullets: ["Subject profiles", "Unseen-first feed", "Multi-card explanations", "Viewed and saved filters"] },
      { title: "Use reels for recall, not syllabus replacement", body: ["Short cards are useful for revision, discovery and recall. Full lessons, solved papers and mocks remain necessary for complete preparation.", "When a card exposes a weak concept, move from the feed into a focused lesson or question practice session."], steps: ["Read the heading before the detail.", "Answer interactive cards honestly.", "Save only revision-worthy posts.", "Open the full subject when context is missing."] },
      { title: "Current affairs stays time-aware", body: ["Current-affairs posts can combine tutorial data with recent national and international developments. Fresh items appear as unseen content while temporary fetched material is managed separately from the built-in offline bank."], bullets: ["National and international mix", "Latest-first current affairs", "Official source links where available", "Offline built-in study cards"] }
    ]
  },
  {
    slug: "offline-css-preparation-progress-app",
    title: "Offline CSS Preparation App with Progress",
    description: "Learn offline with locally saved lesson, vocabulary, MCQ, mock and reading progress that synchronizes quietly when internet returns.",
    category: "App Features",
    type: "offline",
    heading: "Preview offline-first progress",
    summary: "The study interface uses local state first so opening a lesson, vocabulary card or MCQ attempt does not depend on a live request.",
    takeaways: ["Continue core study flows without constant internet.", "Return to the saved lesson or question position.", "Synchronize signed-in progress quietly when online."],
    steps: ["Download and open the app once.", "Study from available local content.", "Leave and resume normally.", "Reconnect later for background synchronization."],
    sections: [
      { title: "Offline-first means the screen does not wait", body: ["Connectivity in Pakistan is not always stable. Core learning progress should therefore be written locally before any optional server synchronization.", "This approach keeps lessons, visited vocabulary and quiz attempts responsive while avoiding a loading screen for every small action."], bullets: ["Local lesson position", "Local vocabulary history", "Local quiz attempts", "Cached current-affairs fallback"] },
      { title: "What synchronization adds", body: ["For signed-in users, synchronized progress can help restore activity on another device. It should merge without duplicating notes, visits or test attempts and should not erase local data during logout."], steps: ["Save locally first.", "Queue pending changes.", "Merge when connectivity is stable.", "Keep the newest valid progress state."] },
      { title: "A practical mobile study routine", body: ["Open lessons or practice while connected when possible, then continue from the available local library during travel, load-shedding or weak network periods."], bullets: ["Read one lesson section", "Complete a short MCQ set", "Review five vocabulary cards", "Reconnect when convenient"] }
    ]
  }
];

const featureSeoDetails = {
  "solved-papers": {
    primaryKeyword: "CSS solved past papers app Pakistan",
    secondaryKeywords: ["solved CSS papers by subject", "CSS past papers Android app", "CSS past papers iPhone app"],
    proofPoints: ["Subject and year filters", "Structured answer sections", "Saved reading position"],
    relatedGuides: ["/css-past-papers", "/css-subjects", "/blog/css-past-papers-method", "/aspirant-app"],
    section: {
      title: "What the Aspirant solved-paper preview demonstrates",
      body: [
        "The preview reflects the same decision path a candidate follows in the app: select a CSS subject, choose an available year, open a question and move through its answer sections. This is intentionally different from opening a long PDF and repeatedly searching for a page number.",
        "The practical advantage is continuity. A reading position can remain associated with the paper, while pinned subjects reduce the number of steps needed to return to frequently studied material. The app experience is designed for both quick question review and longer answer-reading sessions."
      ],
      bullets: ["Find a paper through subject and year rather than a file name.", "Move between question parts and the next complete question.", "Keep formulas, tables and structured answers readable on mobile screens.", "Return to a paper without rebuilding the same navigation path."]
    }
  },
  mcqs: {
    primaryKeyword: "CSS past paper MCQs app",
    secondaryKeywords: ["CSS MCQs with answers", "CSS subject wise MCQs", "CSS past paper quiz Pakistan"],
    proofPoints: ["Year-wise practice", "Accuracy tracking", "Offline resume"],
    relatedGuides: ["/css-past-papers", "/mpt-past-papers", "/blog/css-past-papers-method", "/aspirant-app"],
    section: {
      title: "What the CSS MCQ preview demonstrates",
      body: [
        "The demo shows the complete micro-interaction that matters during practice: read the stem, select an option and receive a clear correction. In the app, that interaction sits inside a paper session with answered count, score, timing and saved progress.",
        "Candidates can use a single year for a focused paper attempt or combine available years for broader revision. The useful output is not merely a green or red option; it is a record of which subject and paper produced the error."
      ],
      bullets: ["Practise by subject and paper year.", "Pause timing when the attempt is no longer active.", "Resume the saved question after an interruption.", "Reset deliberately when a completely fresh attempt is required."]
    }
  },
  vocabulary: {
    primaryKeyword: "CSS vocabulary app with Urdu meanings",
    secondaryKeywords: ["English vocabulary for CSS Pakistan", "vocabulary images Urdu meaning", "CSS vocabulary builder app"],
    proofPoints: ["Easy Urdu meanings", "Usage sentences", "Visited-word history"],
    relatedGuides: ["/blog/css-precis-composition", "/blog/css-english-improvement", "/study-plan", "/aspirant-app"],
    section: {
      title: "What the vocabulary preview demonstrates",
      body: [
        "The sample card shows why Aspirant treats vocabulary as a recall task rather than a list to scroll. A learner first sees the word, then connects it with an easy Urdu meaning, useful synonyms, a visual cue and an English sentence.",
        "Visited history prevents every session from returning to the first word. Previous and next controls follow the learner's actual path, while saved local progress keeps the card interaction responsive even when the network is unavailable."
      ],
      bullets: ["Understand the word before memorising synonyms.", "See how the word behaves in a complete English sentence.", "Use visuals as memory cues rather than decoration.", "Continue from visited vocabulary instead of starting again."]
    }
  },
  "mpt-mocks": {
    primaryKeyword: "CSS MPT mock test app Pakistan",
    secondaryKeywords: ["CSS MPT 200 questions mock", "MPT past papers app", "CSS MPT timed practice"],
    proofPoints: ["200-question mocks", "200-minute timer", "Resume and scoring"],
    relatedGuides: ["/mpt-2027", "/mpt-past-papers", "/blog/css-mpt-beginner-guide", "/aspirant-app"],
    section: {
      title: "What the timed MPT preview demonstrates",
      body: [
        "The preview represents a full mock workflow rather than a collection of unrelated questions. A test has a defined question count, countdown, current position, selected answers and a result that can be reviewed after completion.",
        "If the candidate leaves the active test screen or switches apps, the saved attempt should remain available instead of silently becoming a new test. This makes a long MPT mock practical on a phone without turning every interruption into lost work."
      ],
      bullets: ["Attempt full-length 200-question mock tests.", "Use the 200-minute countdown as a pacing signal.", "Move backward to review an earlier response.", "Resume or reset through explicit controls."]
    }
  },
  reels: {
    primaryKeyword: "CSS study reels app Pakistan",
    secondaryKeywords: ["CSS learning reels", "MPT MCQ reels", "current affairs study feed"],
    proofPoints: ["Unseen-first feed", "Course rotation", "Saved study cards"],
    relatedGuides: ["/current-affairs", "/blog/current-affairs-for-css", "/study-plan", "/aspirant-app"],
    section: {
      title: "What the study-feed preview demonstrates",
      body: [
        "The feed preview is built around a complete learning point: a fact, formula, vocabulary card, MCQ or short lesson extract. Course identity stays visible so the learner knows whether a card belongs to Pakistan Affairs, GSA, MPT, Islamiyat, English or another supported profile.",
        "Unseen-first ordering and course rotation reduce immediate repetition. Viewed and saved states remain useful outside the feed, allowing a candidate to return to material intentionally instead of waiting for the same card to appear again."
      ],
      bullets: ["Rotate through different CSS and MPT course profiles.", "Keep multi-card explanations inside one post.", "Open a course profile for focused study.", "Filter saved and previously viewed learning cards."]
    }
  },
  offline: {
    primaryKeyword: "offline CSS preparation app Pakistan",
    secondaryKeywords: ["offline CSS lessons app", "offline MPT MCQs", "CSS progress sync app"],
    proofPoints: ["Local-first progress", "Offline lessons and tests", "Quiet synchronization"],
    relatedGuides: ["/aspirant-app", "/study-plan", "/css-past-papers", "/mpt-past-papers"],
    section: {
      title: "What offline-first progress means in practice",
      body: [
        "A study action should not wait for a server response before the interface can continue. Lesson position, vocabulary visits and supported quiz attempts are written locally first so weak connectivity does not interrupt every tap or scroll.",
        "When a signed-in learner later has a stable connection, synchronization can carry supported progress to the backend without deleting the local record during logout. Live news and cross-device restoration still require connectivity, but the built-in study flow remains useful without a constant signal."
      ],
      bullets: ["Open available built-in study content without a live request.", "Save the latest lesson or question position locally.", "Keep local learning history when signed out.", "Synchronize supported progress after connectivity returns."]
    }
  }
};

const featureBlogPosts = featurePostSpecs.map((post, index) => ({
  ...post,
  sections: [...post.sections, featureSeoDetails[post.type].section],
  path: `/blog/${post.slug}`,
  readingTime: "8 min read",
  datePublished: "2026-08-29",
  dateModified: "2026-08-29",
  keywords: [
    featureSeoDetails[post.type].primaryKeyword,
    ...featureSeoDetails[post.type].secondaryKeywords,
    "Aspirant CSS app",
    "CSS preparation app Pakistan",
    "Android CSS app",
    "iPhone CSS app"
  ].join(", "),
  tags: [
    post.category,
    featureSeoDetails[post.type].primaryKeyword,
    ...featureSeoDetails[post.type].secondaryKeywords,
    "Aspirant CSS app",
    "Android",
    "iPhone"
  ],
  chart: [
    { label: "Learn", value: 88, helper: "Structured content" },
    { label: "Practise", value: 82, helper: "Interactive flow" },
    { label: "Resume", value: 94, helper: "Saved locally" },
    { label: "Review", value: 86, helper: "Return anytime" }
  ],
  checklist: [...post.steps, "Download the correct version for your phone and try the previewed feature."],
  matrix: [
    { label: "Learn", read: "Focused", practice: "In app", evidence: "Structured" },
    { label: "Resume", read: "Saved", practice: "Offline", evidence: "Progress" },
    { label: "Review", read: "Quick", practice: "Repeat", evidence: "History" }
  ],
  faq: [
    { question: `Is ${post.title.replace(/\bwith\b.*$/i, "").toLowerCase()} available on Android and iPhone?`, answer: "Yes. Aspirant CSS is available from Google Play and the Apple App Store. Mobile visitors can use the download action on this page to open the correct store." },
    { question: "Can I try the feature before downloading?", answer: "Yes. The interactive preview on this page demonstrates the main screen flow with a small sample. The app contains the complete supported experience." },
    { question: "Does Aspirant work when internet is weak?", answer: "Core built-in learning content and locally saved progress are designed to remain useful offline. Live updates and cross-device synchronization require connectivity." }
  ],
  sourceReminder: [sourceLinks[0]],
  relatedGuides: featureSeoDetails[post.type].relatedGuides,
  featurePreview: {
    type: post.type,
    heading: post.heading,
    summary: post.summary,
    proofPoints: featureSeoDetails[post.type].proofPoints
  },
  order: index + 1
}));

const completeAppFeaturesPost = {
  slug: "aspirant-css-app-complete-features",
  path: "/blog/aspirant-css-app-complete-features",
  title: "Aspirant CSS App Features: Complete Android & iPhone Guide",
  description:
    "Explore every major Aspirant CSS app feature for CSS, MPT and PMS preparation: subjects, lectures, solved papers, MCQs, mocks, vocabulary, current affairs, reels, offline study and progress sync.",
  category: "App Features",
  readingTime: "14 min read",
  datePublished: "2026-09-14",
  dateModified: "2026-09-14",
  appFeatureArticle: true,
  keywords: [
    "Aspirant CSS app features",
    "best CSS preparation app Pakistan",
    "CSS MPT app Android iPhone",
    "CSS solved past papers app",
    "CSS MCQs and mock test app",
    "offline CSS preparation app",
    "CSS current affairs app Pakistan",
    "CSS study reels",
    "Aspirant CSS app"
  ].join(", "),
  tags: [
    "Aspirant CSS app",
    "CSS preparation app Pakistan",
    "CSS MPT preparation",
    "Solved CSS papers",
    "CSS MCQs",
    "Offline study",
    "Android",
    "iPhone"
  ],
  takeaways: [
    "Study compulsory and optional CSS subjects through the syllabus, structured lectures and connected course resources.",
    "Practise solved written papers, past-paper MCQs, subject question banks and five full MPT mocks.",
    "Revise vocabulary, current affairs and mixed course content through focused study reels.",
    "Keep supported progress available offline and synchronize it when a stable connection returns.",
    "Download the same preparation platform from Google Play or the Apple App Store."
  ],
  steps: [
    "Create or open your Aspirant CSS account.",
    "Build My Selected Subjects from the compulsory and optional catalogue.",
    "Open a subject and choose its syllabus, lectures, papers, MCQs or reels.",
    "Complete a short practice block and let progress save locally.",
    "Return through resume, saved items or your selected-subject list."
  ],
  sections: appFeatureGroups.map((group) => ({
    title: group.title,
    body: [group.summary],
    bullets: group.features.map((feature) => `${feature.title}: ${feature.text}`)
  })),
  chart: [
    { label: "Learn", value: 94, helper: "Subjects and lectures" },
    { label: "Practise", value: 92, helper: "Papers, MCQs and mocks" },
    { label: "Revise", value: 90, helper: "Reels and vocabulary" },
    { label: "Continue", value: 96, helper: "Offline-first progress" }
  ],
  checklist: [
    "Download the correct Android or iPhone version.",
    "Choose the CSS subjects relevant to your combination.",
    "Start one lecture, one MCQ set and one written-paper question.",
    "Save a useful reel and verify that resume returns to the right place.",
    "Use live content online and keep built-in study material available for offline sessions."
  ],
  matrix: [
    { label: "Subjects", read: "Syllabus + lectures", practice: "MCQs", evidence: "Progress" },
    { label: "Written exam", read: "Solved papers", practice: "Outlines", evidence: "Resume" },
    { label: "MPT", read: "Corrections", practice: "Mocks", evidence: "Scores" },
    { label: "Revision", read: "Reels + vocab", practice: "Recall", evidence: "Saved history" }
  ],
  faq: [
    { question: "What is included in the Aspirant CSS app?", answer: "Aspirant includes available CSS subject syllabus and lectures, solved written papers, past and practice MCQs, MPT past papers and mocks, vocabulary, current affairs, study reels, notes and saved progress." },
    { question: "Is Aspirant CSS available for Android and iPhone?", answer: "Yes. The official Aspirant CSS app is available from Google Play and the Apple App Store." },
    { question: "Can Aspirant CSS work offline?", answer: "Built-in learning material and supported local progress remain useful offline. Live news, newly published content and cross-device synchronization require internet access." },
    { question: "Does the app cover optional CSS subjects?", answer: "Yes. Aspirant provides the CSS subject catalogue and available learning resources for compulsory and optional subjects, organized through FPSC groups." },
    { question: "Does Aspirant replace official FPSC information?", answer: "No. Aspirant is an independent DevZona Labs product. Candidates should verify changing rules, dates, advertisements and official syllabi with FPSC or the relevant commission." }
  ],
  sourceReminder: [sourceLinks[0], sourceLinks[1]],
  relatedGuides: ["/aspirant-app", "/css-subjects", "/css-past-papers", "/mpt-past-papers"]
};

const generatedAndFeatureBlogPosts = [completeAppFeaturesPost, ...featureBlogPosts, ...generatedBlogPosts];

export const blogPosts = generatedAndFeatureBlogPosts.map((post, index) => {
  const sameCategory = generatedAndFeatureBlogPosts.filter(
    (candidate) => candidate.category === post.category && candidate.path !== post.path
  );
  const adjacent = [generatedAndFeatureBlogPosts[index - 1], generatedAndFeatureBlogPosts[index + 1]].filter(Boolean);
  const evergreen = [
    generatedAndFeatureBlogPosts.find((candidate) => candidate.slug === "css-from-zero"),
    generatedAndFeatureBlogPosts.find((candidate) => candidate.slug === "css-past-papers-method"),
    generatedAndFeatureBlogPosts.find((candidate) => candidate.slug === "css-answer-writing"),
    generatedAndFeatureBlogPosts.find((candidate) => candidate.slug === "css-notes-system")
  ].filter(Boolean);
  const relatedPosts = uniqueList(
    [...sameCategory, ...adjacent, ...evergreen]
      .filter((candidate) => candidate.path !== post.path)
      .map((candidate) => candidate.path)
  ).slice(0, 4);

  return {
    ...post,
    relatedGuides: post.slug === "css-answer-writing"
      ? ["/answer-writing-tips", ...post.relatedGuides]
      : post.relatedGuides,
    relatedPosts
  };
});

export const answerWritingTip = {
  weak: [
    "Globalisation connects countries through trade, technology and culture.",
    "It creates economic opportunities, improves communication and increases international cooperation.",
    "However, it also causes inequality, cultural challenges and economic dependence."
  ],
  stronger: [
    {
      label: "Historical + international",
      text: "Since the WTO began on 1 January 1995, trade has become more institutionally connected: its 166 members account for about 98% of world trade.",
      sources: ["wto"]
    },
    {
      label: "Evidence + Pakistan link",
      text: "UNCTAD reported that global goods and services trade reached $35 trillion in 2025, up about 7.5%. Pakistan’s CPEC, launched in 2015, illustrates regional connectivity. Article 40 of Pakistan’s Constitution and UN Charter Article 1(3) provide broader principles of international cooperation—not legal mandates for CPEC.",
      sources: ["unctad", "cpec", "constitution", "unCharter"]
    },
    {
      label: "Critical + future analysis",
      text: "Yet COVID-19-era (2020) supply-chain disruption and newer geopolitical tensions show that gains are uneven. In its October 2026 outlook, the WTO projected merchandise trade volume growth of 3.9% in 2026 and 4.1% in 2027; these are forecasts, not guaranteed outcomes. For Pakistan, this suggests a need for more resilient supply chains and diversified exports.",
      sources: ["outlook"]
    }
  ],
  evidence: [
    { label: "References", example: "WTO and UNCTAD" },
    { label: "Dates", example: "1995, 2015, 2025–27" },
    { label: "Legal context", example: "Pakistan Constitution Art. 40; UN Charter Art. 1(3)" },
    { label: "National and global events", example: "CPEC and COVID-19-era disruption" },
    { label: "Numbers", example: "166 members, 98%, $35 trillion" },
    { label: "Interpreted facts", example: "Trade scale linked to Pakistan’s response" },
    { label: "Time horizon", example: "Past evidence → present risk → future implication" }
  ],
  sources: {
    wto: { label: "WTO Annual Report 2026", url: "https://www.wto.org/english/res_e/publications_e/anrepiframe/index.html" },
    unctad: { label: "UNCTAD Global Trade Update, April 2026", url: "https://unctad.org/publication/global-trade-update-april-2026-global-trade-growth-continues-fragility-rises" },
    cpec: { label: "CPEC Secretariat: project background", url: "https://cpec.gov.pk/news/79" },
    constitution: { label: "Constitution of Pakistan, Article 40", url: "https://pakistancode.gov.pk/pdffiles/administrator9d8e2ecc414c6d3371ac41114b61a2c4.pdf" },
    unCharter: { label: "UN Charter, Article 1(3)", url: "https://www.un.org/about-us/un-charter/chapter-1" },
    outlook: { label: "WTO Global Trade Outlook, October 2026", url: "https://www.wto.org/english/news_e/news26_e/stat_08oct26_510_e.htm" }
  }
};

const blogCards = [
  ...blogPosts.slice(0, 6).map((post) => ({
    title: post.title,
    text: post.description,
    path: post.path
  })),
  {
    title: "Open the full CSS blog shelf",
    text: "See all beginner guides for subjects, MPT, notes, books, answer writing and study planning.",
    path: "/blogs"
  }
];

const featuredBlogCards = blogPosts.slice(0, 6).map((post) => ({
  title: post.title,
  text: post.description,
  path: post.path
}));

const allBlogCards = blogPosts.map((post) => ({
  title: post.title,
  text: `${post.category} · ${post.description}`,
  path: post.path
}));

const blogPages = Object.fromEntries(
  blogPosts.map((post) => [
    post.path,
    {
      ...post,
      kind: "blog",
      hero: {
        eyebrow: post.category,
        headline: post.title,
        summary: post.description,
        words: [post.category, "Beginner guide", "Action steps"]
      },
      stats: [
        { label: "Category", value: post.category },
        { label: "Reading", value: post.readingTime },
        { label: "Level", value: "Beginner" },
        { label: "Action", value: "Today" }
      ],
      related: ["/blogs", "/css-2027", "/css-subjects", "/study-plan"],
      schemaKind: "blog"
    }
  ])
);

const baseSeoTags = [
  "CSS preparation Pakistan",
  "CSS 2027",
  "CSS MPT",
  "PMS Punjab",
  "FPSC CSS",
  "PPSC PMS",
  "Aspirant CSS",
  "AI study planning",
  "progress tracking",
  "web portal",
  "mobile app"
];

const routeSeoTags = {
  "/": [
    "CSS preparation web portal",
    "CSS preparation mobile app",
    "Android CSS app",
    "iOS CSS app",
    "CSS books and notes"
  ],
  "/exam-calendar": [
    "CSS 2027 calendar",
    "CSS MPT expected schedule",
    "PMS Punjab schedule",
    "FPSC notice tracking",
    "PPSC source check"
  ],
  "/css-2027": [
    "CSS 2027 preparation guide",
    "CSS from zero",
    "CSS roadmap",
    "CSS written exam",
    "CSS first week plan"
  ],
  "/css-eligibility": [
    "CSS eligibility criteria",
    "CSS age limit",
    "CSS attempts",
    "CSS documents",
    "CSS application checklist"
  ],
  "/css-subjects": [
    "CSS optional subjects",
    "CSS subject groups",
    "CSS compulsory subjects",
    "CSS 600 marks optionals",
    "CSS subject selection"
  ],
  "/css-syllabus": [
    "CSS syllabus 2027",
    "FPSC CSS syllabus PDF",
    "CSS compulsory subjects syllabus",
    "CSS optional subjects syllabus",
    "CSS 1200 marks structure"
  ],
  "/css-past-papers": [
    "CSS past papers",
    "CSS solved past papers",
    "CSS past papers Pakistan",
    "FPSC CSS past papers",
    "CSS subject wise past papers"
  ],
  "/mpt-past-papers": [
    "MPT past papers",
    "CSS MPT past papers",
    "MPT solved MCQs",
    "MPT mock tests",
    "FPSC MPT preparation"
  ],
  "/mpt-result-2026": [
    "MPT 2026 answer key",
    "CSS MPT 2026 batch 1 answer key",
    "CSS MPT 2026 batch 2 answer key",
    "FPSC CE 2027 MPT answer keys"
  ],
  "/blogs": [
    "CSS blogs Pakistan",
    "CSS beginner blogs",
    "CSS study guides",
    "CSS answer writing",
    "CSS past papers"
  ],
  "/mpt-2027": [
    "CSS MPT 2027",
    "CSS MPT preparation",
    "MPT MCQs",
    "MPT error log",
    "FPSC MPT"
  ],
  "/pms-preparation": [
    "PMS preparation Pakistan",
    "PMS Punjab preparation",
    "PPSC PMS syllabus",
    "PMS past papers",
    "PMS compulsory and optional subjects"
  ],
  "/study-plan": [
    "CSS study plan",
    "CSS timetable",
    "CSS weekly plan",
    "CSS revision plan",
    "CSS progress tracker"
  ],
  "/contact": [
    "Contact Aspirant",
    "CSS preparation help",
    "PMS preparation help",
    "MPT preparation help",
    "Aspirant updates"
  ],
  "/about": [
    "About Aspirant CSS",
    "Aspirant editorial standards",
    "DevZona Labs education platform",
    "CSS content review process"
  ],
  "/css-vista": [
    "CSS Vista",
    "CSSVista",
    "CSS Vista Pakistan",
    "CSS Vista official website",
    "CSS Vista CSS preparation",
    "CSS Vista DevZona Labs"
  ],
  "/aspirant-app": [
    "Aspirant CSS app",
    "Aspirant Android app",
    "Aspirant iPhone app",
    "CSS preparation mobile app",
    "MPT preparation app",
    "PMS preparation app",
    "CSS MCQs app Pakistan",
    "CSS vocabulary flashcards",
    "CSS solved past papers app",
    "CSS study app Pakistan"
  ],
  "/sitemap": [
    "Aspirant sitemap",
    "CSS pages",
    "CSS guide index",
    "Aspirant routes"
  ]
};

function uniqueList(items) {
  return [...new Set(items.filter(Boolean).map((item) => String(item).trim()).filter(Boolean))];
}

function tagsToKeywords(tags, page) {
  return uniqueList([
    ...(tags || []),
    page?.title,
    page?.category,
    "CSS preparation Pakistan",
    "Aspirant CSS"
  ]).join(", ");
}

function enrichPageSeo(page) {
  const routeTags = routeSeoTags[page.path] || [];
  const pageTags = uniqueList([
    ...baseSeoTags,
    ...routeTags,
    ...(page.tags || []),
    page.category,
    page.title
  ]);

  return {
    ...page,
    tags: pageTags,
    keywords: page.keywords || tagsToKeywords(pageTags, page)
  };
}

function absoluteAssetUrl(assetUrl) {
  if (!assetUrl) return brand.url;
  return assetUrl.startsWith("http") ? assetUrl : `${brand.url}${assetUrl}`;
}

function pageFaq(page) {
  return [
    ...(page.faq || []),
    ...(page.sections || []).flatMap((section) => section.faq || [])
  ];
}

function contentList(value) {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
}

function faqSchema(page) {
  const faq = pageFaq(page);
  if (!faq.length) return null;

  return {
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }))
  };
}

function breadcrumbSchema(page) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: brand.url },
      { "@type": "ListItem", position: 2, name: page.title, item: `${brand.url}${page.path}` }
    ]
  };
}

function articleSchema(page) {
  const articleBody = [
    page.description,
    ...(page.takeaways || []),
    ...(page.steps || []),
    ...(page.sections || []).flatMap((section) => [
      section.title,
      ...contentList(section.body),
      ...(section.bullets || []),
      ...(section.steps || []),
      ...(section.cards || []).flatMap((card) => [card.title, card.text]),
      ...(section.faq || []).flatMap((item) => [item.question, item.answer])
    ])
  ]
    .filter(Boolean)
    .join(" ");

  return {
    "@type": page.kind === "blog" ? "BlogPosting" : "Article",
    headline: page.title,
    description: page.description,
    keywords: page.keywords,
    articleSection: page.category || page.kind,
    wordCount: articleBody && page.kind !== "answer-tip" ? articleBody.split(/\s+/).length : undefined,
    datePublished: page.datePublished || page.dateModified || "2026-06-15",
    dateModified: page.dateModified || "2026-06-15",
    author: { "@type": "Organization", name: brand.name, url: `${brand.url}/about` },
    editor: { "@type": "Organization", name: "Aspirant CSS editorial team", url: `${brand.url}/about` },
    publisher: {
      "@type": "Organization",
      name: brand.name,
      url: brand.url,
      logo: { "@type": "ImageObject", url: absoluteAssetUrl(brand.logo) }
    },
    image: absoluteAssetUrl(brand.cover),
    isAccessibleForFree: true,
    about: [
      "CSS preparation Pakistan",
      "CSS 2027",
      page.category || "CSS guide",
      ...(page.tags || []).slice(0, 8)
    ],
    mentions: (page.sourceReminder || sourceLinks).map((source) => ({
      "@type": "Organization",
      name: source.name,
      url: source.url
    })),
    mainEntityOfPage: `${brand.url}${page.path}`,
    inLanguage: "en"
  };
}

function featureAppSchemas(page) {
  if (!page.featurePreview && !page.appFeatureArticle) return [];

  const featureList = page.appFeatureArticle
    ? appFeatureList
    : page.featurePreview.proofPoints || [];

  const sharedProperties = {
    "@type": "MobileApplication",
    name: "Aspirant CSS – CSS MPT Exam Prep",
    alternateName: "Aspirant CSS",
    description: page.featurePreview?.summary || page.description,
    applicationCategory: "EducationalApplication",
    applicationSubCategory: "Test Preparation",
    image: absoluteAssetUrl(brand.logo),
    featureList,
    author: {
      "@type": "Organization",
      name: "DevZona Labs",
      url: brand.url
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "PKR",
      availability: "https://schema.org/InStock"
    },
    isAccessibleForFree: true,
    countriesSupported: "PK",
    inLanguage: ["en-PK", "ur-PK"]
  };

  return [
    {
      ...sharedProperties,
      "@id": `${brand.url}/aspirant-app#android-app`,
      operatingSystem: "Android",
      softwareVersion: appStores.android.version,
      identifier: appStores.android.identifier,
      url: appStores.android.url,
      downloadUrl: appStores.android.url,
      installUrl: appStores.android.url
    },
    {
      ...sharedProperties,
      "@id": `${brand.url}/aspirant-app#ios-app`,
      operatingSystem: "iOS",
      softwareVersion: appStores.ios.version,
      identifier: appStores.ios.identifier,
      url: appStores.ios.url,
      downloadUrl: appStores.ios.url,
      installUrl: appStores.ios.url
    }
  ];
}

function webPageSchema(page) {
  const schema = {
    "@type": "WebPage",
    name: page.title,
    description: page.description,
    keywords: page.keywords,
    about: (page.tags || []).map((tag) => ({
      "@type": "Thing",
      name: tag
    })),
    url: `${brand.url}${page.path === "/" ? "/" : page.path}`,
    significantLink: [appStores.android.url, appStores.ios.url],
    dateModified: page.dateModified,
    isPartOf: { "@id": `${brand.url}/#website` },
    inLanguage: "en"
  };

  if (page.featurePreview || page.appFeatureArticle) {
    schema.mainEntity = [
      { "@id": `${brand.url}/aspirant-app#android-app` },
      { "@id": `${brand.url}/aspirant-app#ios-app` }
    ];
  }

  return schema;
}

function officialBrandSchemas() {
  return [
    {
      "@type": "Brand",
      "@id": `${brand.url}/#aspirant-css-brand`,
      name: "Aspirant CSS",
      url: brand.url,
      logo: absoluteAssetUrl(brand.logo)
    },
    {
      "@type": "Brand",
      "@id": `${brand.url}/css-vista#brand`,
      name: "CSS Vista",
      alternateName: ["CSSVista", "CSS Vista Pakistan"],
      url: `${brand.url}/css-vista`,
      logo: absoluteAssetUrl(brand.logo),
      sameAs: ["https://cssvista.pk/", "https://cssvista.com.pk/"]
    }
  ];
}

function devZonaOrganizationSchema() {
  return {
    "@type": "Organization",
    "@id": `${brand.url}/#organization`,
    name: "DevZona Labs",
    url: brand.url,
    logo: absoluteAssetUrl(brand.logo),
    email: "hamza@devzona.com",
    brand: officialBrandSchemas().map((officialBrand) => ({ "@id": officialBrand["@id"] })),
    sameAs: [appStores.android.url, appStores.ios.url, socialProfiles.instagram.url]
  };
}

export const pages = {
  "/": {
    path: "/",
    kind: "home",
    title: "CSS, MPT & PMS Preparation Pakistan",
    description:
      "Prepare CSS, MPT and PMS in Pakistan with subject syllabus, lectures, solved papers, past and practice MCQs, full mocks, vocabulary, current affairs, study reels and offline progress.",
    dateModified: "2026-09-14",
    hero: {
      eyebrow: "CSS guide",
      headline: "New to CSS? Start here."
    },
    stats: [
      { label: "Learn", value: "Structured subjects" },
      { label: "Read", value: "Solved papers" },
      { label: "Practice", value: "MCQs & mocks" },
      { label: "Revise", value: "Study reels" }
    ],
    sections: [
      {
        eyebrow: "Reception desk",
        title: "If you know nothing about CSS, follow this order",
        body: [
          "Most beginners get stuck because they open books before understanding the exam. Start with the map, then move one shelf at a time."
        ],
        cards: [
          { title: "1. What is CSS?", text: "A competitive exam with screening, written papers, interview and final allocation.", path: "/css-2027" },
          { title: "2. Can I apply?", text: "Check age, degree, attempts, domicile and documents before planning too far.", path: "/css-eligibility" },
          { title: "3. What do I study?", text: "See compulsory papers and all optional groups in one place.", path: "/css-subjects" },
          { title: "4. What should I do today?", text: "Start with English, one current issue, simple MCQs and a small revision block.", path: "/study-plan" }
        ]
      },
      {
        eyebrow: "Popular preparation routes",
        title: "Open the exact CSS, MPT or PMS resource you need",
        body: [
          "These focused preparation pages connect the official exam structure with practical study actions, papers and revision."
        ],
        cards: [
          { title: "CSS syllabus 2027", text: "Understand compulsory papers, optional groups, marks and how to read the FPSC syllabus.", path: "/css-syllabus" },
          { title: "CSS solved past papers", text: "Use subject-wise papers to identify themes, command words and answer structures.", path: "/css-past-papers" },
          { title: "Answer writing: boring vs strong", text: "Compare answers across 52 CSS subject entries, from compulsory papers to optional groups.", path: "/answer-writing-tips" },
          { title: "MPT past papers and MCQs", text: "Practice screening-test questions by year, record mistakes and build timed accuracy.", path: "/mpt-past-papers" },
          { title: "PMS preparation Pakistan", text: "Plan provincial competitive-exam preparation with a clear syllabus and past-paper method.", path: "/pms-preparation" },
          { title: "Aspirant CSS mobile app", text: "Download the CSS, MPT and PMS preparation app for Android or iPhone.", path: "/aspirant-app" }
        ]
      },
      {
        type: "appFeatureShowcase",
        eyebrow: "Inside the Aspirant app",
        title: "A complete CSS preparation workspace",
        body: [
          "Explore the complete user-facing feature set across Android and iPhone without turning the homepage into a heavy app demo."
        ],
        featureGroups: appFeatureGroups
      },
      {
        eyebrow: "Beginner blogs",
        title: "Six guides to start with",
        body: ["Start with these. The full blog shelf has 30+ beginner guides."],
        cards: blogCards
      }
    ],
    related: ["/aspirant-app", "/css-2027", "/css-syllabus", "/css-past-papers", "/mpt-past-papers", "/pms-preparation", "/blogs"],
    schemaKind: "home"
  },
  "/exam-calendar": {
    path: "/exam-calendar",
    kind: "guide",
    title: "CSS 2027 & PMS Exam Calendar",
    description:
      "Expected CSS 2027 MPT, written exam and PMS Punjab planning calendar with FPSC and PPSC source links.",
    hero: {
      eyebrow: "Calendar wall",
      headline: "A quiet calendar for the long CSS cycle.",
      words: ["Notice", "Apply", "MPT", "Written", "PMS"],
      summary:
        "Use this page like a wall calendar in a study room: see the expected window, then do the next small action.",
      chips: ["Aug-Sep notice watch", "Oct-Nov MPT target", "Feb written target", "PPSC PMS checks"]
    },
    stats: [
      { label: "MPT watch", value: "Aug-Sep 2026" },
      { label: "MPT target", value: "Oct-Nov 2026" },
      { label: "Written target", value: "Feb 2027" },
      { label: "PMS", value: "Weekly checks" }
    ],
    sections: [
      {
        eyebrow: "Calendar",
        title: "Expected windows, converted into study actions",
        body: [
          "The point is not to create panic. The point is to know when documents, MCQs, written practice, past papers and PMS source checks belong in your week."
        ],
        calendar: {
          monthLabel: "CSS 2027 and PMS planning calendar",
          focusLabel: "Schedule",
          events: calendarEvents
        }
      },
      {
        eyebrow: "Sources",
        title: "Source links to keep near your plan",
        cards: sourceCards
      }
    ],
    related: ["/css-2027", "/mpt-2027", "/css-eligibility", "/css-subjects", "/study-plan"],
    schemaKind: "article"
  },
  "/css-2027": {
    path: "/css-2027",
    kind: "guide",
    title: "CSS 2027 Preparation Guide",
    description:
      "CSS 2027 roadmap for MPT, compulsory papers, optional subjects, essay writing and final revision.",
    hero: {
      eyebrow: "Start here",
      headline: "CSS from zero, arranged on one desk.",
      words: ["Structure", "Eligibility", "MPT", "Subjects", "Week one"],
      summary:
        "If you do not know where to begin, this page gives the order: exam structure, eligibility, MPT, subjects, then a simple weekly rhythm.",
      chips: ["For first-timers", "No jargon first", "Clear sequence", "Small weekly actions"]
    },
    stats: [
      { label: "Written marks", value: "1200" },
      { label: "Compulsory", value: "600" },
      { label: "Optional", value: "600" },
      { label: "Attempts", value: "3" }
    ],
    sections: [
      {
        eyebrow: "Orientation table",
        title: "The beginner sequence",
        cards: [
          { title: "Know the papers", text: "CSS written is 1200 marks: 600 compulsory and 600 optional." },
          { title: "Check eligibility", text: "Confirm age, degree, attempts and documents before making a long plan." },
          { title: "Prepare MPT first", text: "MPT is the screening gate, so MCQs and recall need early attention." },
          { title: "Start writing slowly", text: "Essay, precis and short answers improve through small daily practice." }
        ]
      },
      {
        eyebrow: "Compulsory",
        title: "Six compulsory papers",
        compulsorySubjects
      },
      {
        eyebrow: "Optional",
        title: "Seven optional subject groups",
        subjectGroups: optionalSubjectGroups
      }
    ],
    related: ["/css-syllabus", "/css-past-papers", "/css-eligibility", "/css-subjects", "/mpt-2027", "/study-plan"],
    schemaKind: "article"
  },
  "/css-eligibility": {
    path: "/css-eligibility",
    kind: "guide",
    title: "CSS Eligibility Criteria & Planning Tool",
    description:
      "CSS eligibility planning tool for age, education, attempts, domicile documents and application readiness.",
    hero: {
      eyebrow: "Eligibility",
      headline: "The front desk check before CSS planning.",
      words: ["Age", "Degree", "Attempts", "Domicile"],
      summary:
        "A simple place to check the basic items new candidates usually discover too late."
    },
    stats: [
      { label: "Degree", value: "Bachelor’s" },
      { label: "Attempts", value: "3" },
      { label: "Age range", value: "21-30" },
      { label: "Target", value: "CSS 2027" }
    ],
    sections: [
      {
        eyebrow: "Planning tool",
        title: "CSS eligibility estimate",
        eligibilityTool: true
      },
      {
        eyebrow: "Desk checklist",
        title: "Items to keep in one folder",
        cards: eligibilityCriteria.map((item) => ({ title: item.label, text: item.value }))
      },
      {
        eyebrow: "Application folder",
        title: "Documents to keep ready",
        bullets: [
          "CNIC and recent photo.",
          "Domicile and address details.",
          "Bachelor’s degree, transcript and equivalence if applicable.",
          "Fee proof and application print after submission.",
          "Correct name, father name and dates across documents."
        ]
      }
    ],
    related: ["/exam-calendar", "/css-2027", "/css-subjects", "/mpt-2027", "/study-plan"],
    schemaKind: "article"
  },
  "/css-subjects": {
    path: "/css-subjects",
    kind: "guide",
    title: "CSS Optional Subjects & Group Selection",
    description:
      "CSS optional subjects and group selection guide with compulsory papers, seven optional groups and 600-mark planning structure.",
    hero: {
      eyebrow: "Subjects",
      headline: "Subject shelves before subject selection.",
      words: ["Groups", "Marks", "Overlap", "Past Papers"],
      summary:
        "See the full CSS subject library first. Then choose by background, overlap, paper style and revision capacity."
    },
    stats: [
      { label: "Optional total", value: "600" },
      { label: "Groups", value: "7" },
      { label: "Written total", value: "1200" },
      { label: "Best filter", value: "Revision" }
    ],
    sections: [
      {
        eyebrow: "Compulsory",
        title: "Compulsory papers",
        compulsorySubjects
      },
      {
        eyebrow: "Optional groups",
        title: "CSS optional subject groups",
        subjectGroups: optionalSubjectGroups
      },
      {
        eyebrow: "Selection table",
        title: "How to compare subjects calmly",
        cards: [
          { title: "Background fit", text: "Pick subjects you can understand without starting from zero." },
          { title: "Syllabus overlap", text: "Prefer combinations that support current affairs, governance, law, history or Pakistan affairs." },
          { title: "Paper style", text: "Match your strength: analytical writing, memorization, conceptual theory or calculation." },
          { title: "Revision load", text: "A subject is only good if you can revise it before the written phase." }
        ]
      }
    ],
    related: ["/css-syllabus", "/css-past-papers", "/css-2027", "/css-eligibility", "/mpt-2027", "/study-plan"],
    schemaKind: "article"
  },
  "/css-syllabus": {
    path: "/css-syllabus",
    kind: "guide",
    title: "FPSC CSS Syllabus: Compulsory & Optional Subjects",
    description:
      "Browse the FPSC CSS syllabus for any exam year: 52 subject outlines, six compulsory papers, seven optional groups, marks and suggested readings. Check FPSC for later changes.",
    datePublished: "2026-08-26",
    dateModified: "2026-09-26",
    category: "CSS Syllabus",
    sourceReminder: [sourceLinks[0]],
    hero: {
      eyebrow: "CSS syllabus",
      headline: "Turn the CSS syllabus into a study map.",
      words: ["1200 marks", "Compulsory", "Optional groups", "Past papers"],
      summary:
        "Do not treat the syllabus as a formality. Use every line as a preparation boundary, connect it with past questions and track what has actually been covered.",
      chips: ["FPSC syllabus", "600 compulsory", "600 optional", "Subject map"]
    },
    stats: [
      { label: "Written total", value: "1200" },
      { label: "Compulsory", value: "600" },
      { label: "Optional", value: "600" },
      { label: "Optional groups", value: "7" }
    ],
    sections: [
      {
        eyebrow: "Exam structure",
        title: "What the CSS syllabus contains",
        body: [
          "The CSS written examination carries 1200 marks. Every candidate studies six compulsory papers worth 600 marks and selects another 600 marks from the FPSC optional-subject groups. MPT is a separate screening stage before the written examination."
        ],
        cards: [
          { title: "Compulsory papers", text: "Essay, English Precis & Composition, General Science & Ability, Current Affairs, Pakistan Affairs and Islamic Studies or Comparative Study of Major Religions." },
          { title: "Optional papers", text: "Select 600 marks while obeying the marks limit stated for each of the seven FPSC groups." },
          { title: "MPT screening", text: "Prepare objective recall and timed MCQs separately; MPT preparation does not replace written-answer practice." },
          { title: "Official source", text: "Always confirm the latest scheme, rules and PDF on the FPSC website before final subject selection.", path: "https://www.fpsc.gov.pk/" }
        ]
      },
      {
        eyebrow: "Compulsory syllabus",
        title: "Six papers every CSS candidate prepares",
        compulsorySubjects
      },
      {
        eyebrow: "Optional syllabus",
        title: "Seven groups for the optional 600 marks",
        subjectGroups: optionalSubjectGroups
      },
      {
        eyebrow: "Study method",
        title: "How to convert syllabus lines into preparation",
        steps: [
          "Copy every syllabus topic into a subject checklist.",
          "Attach five to ten years of relevant past-paper questions to each topic.",
          "Choose one base source and one current source instead of collecting unlimited books.",
          "Create short revision notes only after understanding the topic.",
          "Test each topic through recall, an outline or a timed answer."
        ]
      },
      {
        eyebrow: "Quick answers",
        title: "CSS syllabus questions",
        faq: [
          { question: "How many marks are in the CSS written exam?", answer: "The written examination has 1200 marks: 600 compulsory and 600 optional." },
          { question: "How many compulsory CSS papers are there?", answer: "There are six compulsory papers, each carrying 100 marks." },
          { question: "Can I select any combination of optional subjects?", answer: "No. Your selection must total 600 marks and follow the limits of the seven FPSC optional-subject groups." },
          { question: "Should I prepare from the syllabus or from books?", answer: "Use the official syllabus and past papers as boundaries, then choose books and notes that cover those requirements." }
        ]
      }
    ],
    related: ["/css-2027", "/css-subjects", "/css-past-papers", "/mpt-2027", "/study-plan"],
    schemaKind: "article"
  },
  "/css-past-papers": {
    path: "/css-past-papers",
    kind: "guide",
    title: "CSS Past Papers: Solved Papers & Preparation",
    description:
      "Study CSS past papers by subject and year, identify repeated themes, practise outlines and open solved papers in the Aspirant CSS Android and iOS app.",
    datePublished: "2026-08-26",
    dateModified: "2026-08-26",
    category: "CSS Past Papers",
    sourceReminder: [sourceLinks[0]],
    hero: {
      eyebrow: "CSS past papers",
      headline: "Read past papers before reading everything else.",
      words: ["Questions", "Themes", "Outlines", "Solved answers"],
      summary:
        "Past papers reveal what the examiner asks, how topics are combined and which command words require analysis rather than description.",
      chips: ["Subject-wise", "Year-wise", "Solved answers", "Offline app"]
    },
    stats: [
      { label: "Best range", value: "10 years" },
      { label: "First action", value: "Cluster" },
      { label: "Practice", value: "Outline" },
      { label: "Full answers", value: "Timed" }
    ],
    sections: [
      {
        eyebrow: "Past-paper method",
        title: "Use every paper in four passes",
        cards: [
          { title: "1. Scan", text: "Read the complete paper without answering and mark familiar, unfamiliar and repeated areas." },
          { title: "2. Cluster", text: "Group different questions under the same syllabus theme so repetition becomes visible." },
          { title: "3. Outline", text: "Write a thesis, headings, evidence and conclusion plan before attempting full answers." },
          { title: "4. Test", text: "Attempt selected questions under time and review relevance, structure and evidence." }
        ]
      },
      {
        eyebrow: "Solved library",
        title: "Read CSS solved papers on mobile",
        body: [
          "The Aspirant CSS app organizes solved written papers by subject, year and question. It also keeps objective past-paper MCQs separate so written-answer reading does not feel like a mixed database."
        ],
        cards: [
          { title: "Android app", text: "Open solved papers, MCQs, lessons and offline progress on Android.", path: "https://play.google.com/store/apps/details?id=pk.com.aspirant" },
          { title: "iPhone app", text: "Access the Aspirant CSS study portal and solved-paper library on iOS.", path: "https://apps.apple.com/pk/app/aspirant-css-mpt-exam-prep/id6792441265" }
        ]
      },
      {
        eyebrow: "Answer quality",
        title: "What to extract from a solved answer",
        bullets: [
          "A direct thesis that answers the exact command in the question.",
          "Headings that form a logical argument rather than a list of facts.",
          "Evidence such as constitutional provisions, data, cases, examples or scholarly views.",
          "Analysis that explains causes, consequences, limitations and policy choices.",
          "A conclusion that resolves the argument without introducing a new topic."
        ]
      },
      {
        eyebrow: "Quick answers",
        title: "CSS past-paper questions",
        faq: [
          { question: "How many years of CSS past papers should I study?", answer: "Start with the latest ten years, then use older papers when a syllabus topic needs more examples." },
          { question: "Should beginners open past papers before finishing the syllabus?", answer: "Yes. Past papers should guide reading from the beginning so preparation stays relevant to examiner demands." },
          { question: "Are solved past papers enough for CSS preparation?", answer: "No. Use solved answers to study structure and evidence, then verify facts and practise producing your own timed answers." }
        ]
      }
    ],
    related: [
      "/blog/aspirant-solved-css-past-papers-app",
      "/blog/css-past-paper-mcqs-app",
      "/css-syllabus",
      "/css-subjects",
      "/study-plan",
      "/mpt-past-papers",
      "/aspirant-app"
    ],
    schemaKind: "article"
  },
  "/mpt-past-papers": {
    path: "/mpt-past-papers",
    kind: "guide",
    title: "CSS MPT Past Papers, Solved MCQs & Mocks",
    description:
      "Prepare CSS MPT with year-wise past papers, solved MCQs, timed mock tests, error logs and progress tracking in the Aspirant CSS app.",
    datePublished: "2026-08-26",
    dateModified: "2026-08-26",
    category: "MPT Past Papers",
    sourceReminder: [sourceLinks[0]],
    hero: {
      eyebrow: "MPT past papers",
      headline: "Turn every wrong MCQ into a future mark.",
      words: ["Past papers", "Mocks", "Accuracy", "Error log"],
      summary:
        "Year-wise papers show the screening-test pattern. Mixed mocks then test whether you can retrieve that knowledge under time.",
      chips: ["Solved MCQs", "Year filters", "Timed mocks", "Progress tracking"]
    },
    stats: [
      { label: "Paper style", value: "Objective" },
      { label: "Practice", value: "Timed" },
      { label: "Review", value: "48 hours" },
      { label: "Tracking", value: "Offline" }
    ],
    sections: [
      {
        eyebrow: "Practice library",
        title: "Use past papers and mocks for different jobs",
        cards: [
          { title: "MPT 2026 answer keys", text: "Compare Batch 1 morning or Batch 2 evening answers using the matching key.", path: "/mpt-result-2026" },
          { title: "Year-wise MPT papers", text: "Understand actual topic distribution and build familiarity with recurring facts and concepts." },
          { title: "Subject filters", text: "Isolate weak areas such as English, GSA, Pakistan Affairs, Current Affairs or Islamic Studies." },
          { title: "Full mock tests", text: "Test stamina, pacing and decision-making across a complete mixed paper." },
          { title: "Error review", text: "Save wrong and uncertain answers, then attempt them again after a short interval." }
        ]
      },
      {
        eyebrow: "Three-stage routine",
        title: "A better way to solve MPT MCQs",
        steps: [
          "First attempt: answer without notes and mark uncertainty honestly.",
          "Review: understand why the correct option is right and why close alternatives are wrong.",
          "Retest: solve missed concepts again after 48 hours and in the next mixed mock."
        ]
      },
      {
        eyebrow: "Aspirant CSS app",
        title: "Practise MPT past papers offline",
        body: [
          "The mobile app includes MPT tutorial content, past-paper MCQs, full mock tests, timers, reset and resume controls, language support for Islamic Studies and progress that continues offline."
        ],
        cards: [
          { title: "Download for Android", text: "Open MPT papers and mock tests from Google Play.", path: "https://play.google.com/store/apps/details?id=pk.com.aspirant" },
          { title: "Download for iPhone", text: "Prepare with Aspirant CSS on the Apple App Store.", path: "https://apps.apple.com/pk/app/aspirant-css-mpt-exam-prep/id6792441265" }
        ]
      },
      {
        eyebrow: "Quick answers",
        title: "MPT past-paper questions",
        faq: [
          { question: "Are MPT past papers enough for preparation?", answer: "They are essential for pattern awareness, but combine them with syllabus-based study, subject practice and full timed mocks." },
          { question: "How should I review a wrong MPT answer?", answer: "Record the tested concept, the correct fact or rule, and why your selected option was wrong; then retest it after 48 hours." },
          { question: "Can I practise MPT MCQs offline?", answer: "Yes. The Aspirant CSS mobile app is designed to keep available MCQs and saved progress usable offline." }
        ]
      }
    ],
    related: [
      "/mpt-result-2026",
      "/blog/css-mpt-mock-tests-app",
      "/blog/css-past-paper-mcqs-app",
      "/mpt-2027",
      "/css-syllabus",
      "/css-2027",
      "/study-plan",
      "/aspirant-app"
    ],
    schemaKind: "article"
  },
  "/mpt-result-2026": {
    path: "/mpt-result-2026",
    kind: "mpt-result",
    title: "MPT 2026 Answer Keys: Batch 1 Morning & Batch 2 Evening",
    description: "View the FPSC CE-2027 MPT 2026 answer key images for Batch 1 morning and Batch 2 evening. Check the correct batch before comparing answers.",
    datePublished: "2026-10-10",
    dateModified: "2026-10-10",
    category: "MPT Answer Keys",
    related: ["/mpt-past-papers", "/mpt-2027"],
    schemaKind: "webpage"
  },
  "/pms-preparation": {
    path: "/pms-preparation",
    kind: "guide",
    title: "PMS Preparation Pakistan: Syllabus & Study Plan",
    description:
      "PMS preparation guide for Pakistan with provincial exam notices, syllabus, compulsory and optional papers, past papers, English and current affairs.",
    datePublished: "2026-08-26",
    dateModified: "2026-08-26",
    category: "PMS Preparation",
    hero: {
      eyebrow: "PMS preparation",
      headline: "Prepare for PMS without treating it as CSS copy-paste.",
      words: ["Province", "Syllabus", "Past papers", "Writing"],
      summary:
        "PMS rules, vacancies, paper schemes and schedules depend on the relevant provincial commission. Start from the correct notice, then build a paper-specific plan.",
      chips: ["PPSC PMS", "Provincial exams", "Past papers", "Answer writing"]
    },
    stats: [
      { label: "First source", value: "Commission" },
      { label: "First task", value: "Syllabus" },
      { label: "Daily", value: "English" },
      { label: "Weekly", value: "Past paper" }
    ],
    sections: [
      {
        eyebrow: "Start correctly",
        title: "The PMS preparation order",
        steps: [
          "Identify the relevant provincial public service commission and current advertisement.",
          "Confirm eligibility, domicile requirements, age rules, vacancies and the latest paper scheme.",
          "Download the official syllabus and recent past papers for that province.",
          "Separate compulsory preparation from optional-subject preparation.",
          "Build daily English and current-affairs work into the plan from week one."
        ]
      },
      {
        eyebrow: "PMS versus CSS",
        title: "What can overlap and what needs separate preparation",
        cards: [
          { title: "Useful overlap", text: "English, current affairs, Pakistan affairs, general knowledge and several optional subjects may support both exams." },
          { title: "Provincial focus", text: "PMS can require province-specific history, law, administration, geography or current issues depending on the commission." },
          { title: "Different scheme", text: "Marks, paper combinations, screening stages and subject lists can differ; never assume the CSS scheme applies." },
          { title: "Different timing", text: "PMS vacancies and exam dates are advertisement-driven, so preparation should continue before a new notice appears." }
        ]
      },
      {
        eyebrow: "Weekly system",
        title: "A practical PMS preparation week",
        bullets: [
          "Daily English grammar, precis, vocabulary or writing practice.",
          "Two compulsory-paper reading blocks connected to past questions.",
          "Two optional-subject blocks with short revision notes.",
          "One Pakistan and provincial current-affairs briefing.",
          "One timed answer, essay outline or paper section.",
          "One weekly audit of covered syllabus lines and repeated mistakes."
        ]
      },
      {
        eyebrow: "Official checks",
        title: "Use commission sources for final decisions",
        cards: [
          { title: "Punjab Public Service Commission", text: "Check Punjab PMS advertisements, schedules, syllabi and results on PPSC.", path: "https://ppsc.gop.pk/" },
          { title: "FPSC CSS section", text: "Use FPSC only for official CSS and MPT notices, rules and syllabi.", path: "https://www.fpsc.gov.pk/" }
        ]
      },
      {
        eyebrow: "Quick answers",
        title: "PMS preparation questions",
        faq: [
          { question: "Is PMS preparation the same as CSS preparation?", answer: "No. There is useful overlap, but PMS rules, subjects, provincial content and paper schemes depend on the relevant commission." },
          { question: "Can I prepare for PMS before an advertisement?", answer: "Yes. Build English, general knowledge, current affairs and likely subject foundations, then adjust to the official notice when published." },
          { question: "Which website confirms Punjab PMS dates and eligibility?", answer: "The Punjab Public Service Commission website is the final source for Punjab PMS advertisements, schedules, eligibility and syllabi." }
        ]
      }
    ],
    related: ["/exam-calendar", "/study-plan", "/css-2027", "/css-syllabus", "/blogs"],
    schemaKind: "article"
  },
  "/blogs": {
    path: "/blogs",
    kind: "blogs",
    title: "CSS Beginner Blogs",
    description:
      "Beginner-friendly CSS preparation blogs on where to start, optional subject selection, MPT, study plans, writing and compulsory papers.",
    hero: {
      eyebrow: "CSS blogs",
      headline: "Guides for the exact moment you get stuck.",
      words: ["Start", "Subjects", "MPT", "Writing"],
      summary:
        "Short, organized CSS guides for fresh aspirants who need the next clear step instead of another confusing list."
    },
    stats: [
      { label: "Guides", value: `${blogPosts.length}+` },
      { label: "Level", value: "Beginner" },
      { label: "Focus", value: "Decisions" },
      { label: "Format", value: "Action steps" }
    ],
    sections: [
      {
        eyebrow: "All guides",
        title: "CSS beginner reading shelf",
        body: ["Pick the question you have today. Each blog has a clear explanation, key takeaways and steps."],
        cards: allBlogCards
      },
      {
        eyebrow: "Start here first",
        title: "Featured beginner guides",
        cards: featuredBlogCards
      }
    ],
    related: ["/css-2027", "/css-syllabus", "/css-past-papers", "/css-subjects", "/mpt-2027", "/pms-preparation"],
    schemaKind: "collection"
  },
  "/mpt-2027": {
    path: "/mpt-2027",
    kind: "guide",
    title: "CSS MPT 2027 Preparation",
    description:
      "CSS MPT 2027 preparation guide with expected schedule, MCQ routine, topic rotation and error-log strategy.",
    hero: {
      eyebrow: "MPT",
      headline: "The screening test shelf.",
      words: ["MCQs", "Recall", "Mocks", "Accuracy"],
      summary:
        "MPT becomes easier when it has a routine: short topics, timed MCQs, error logs and weekly mixed mocks."
    },
    stats: [
      { label: "Expected test", value: "Oct-Nov" },
      { label: "Mode", value: "MCQs" },
      { label: "Habit", value: "Error log" },
      { label: "Mock", value: "Weekly" }
    ],
    sections: [
      {
        eyebrow: "MPT loop",
        title: "Daily screening-test routine",
        steps: [
          "Read one compact topic.",
          "Solve a timed MCQ set.",
          "Write every mistake in an error log.",
          "Revise missed items after 48 hours.",
          "Take one mixed mock every week."
        ]
      },
      {
        eyebrow: "Topics",
        title: "MPT areas to rotate",
        bullets: [
          "English vocabulary, grammar and comprehension.",
          "Pakistan affairs and current affairs.",
          "Everyday science and general ability.",
          "Islamic Studies or Comparative Study where applicable.",
          "Basic analytical reasoning and quantitative practice."
        ]
      },
      {
        eyebrow: "Calendar",
        title: "MPT preparation windows",
        calendar: {
          monthLabel: "MPT planning calendar",
          focusLabel: "MPT",
          events: calendarEvents.filter((event) => ["FPSC", "MPT", "WRITE"].includes(event.tag))
        }
      }
    ],
    related: ["/mpt-past-papers", "/css-2027", "/css-syllabus", "/css-eligibility", "/css-subjects", "/study-plan"],
    schemaKind: "article"
  },
  "/study-plan": {
    path: "/study-plan",
    kind: "guide",
    title: "CSS Study Plan",
    description:
      "Weekly CSS study plan for MPT, compulsory papers, optional subjects, writing practice and revision.",
    hero: {
      eyebrow: "Study plan",
      headline: "Your first quiet study week.",
      words: ["Read", "Write", "Revise", "Mock"],
      summary:
        "A calm weekly structure for reading, answer writing, MCQs, current affairs and revision."
    },
    stats: [
      { label: "Daily", value: "Writing" },
      { label: "Weekly", value: "Mock" },
      { label: "Monthly", value: "Audit" },
      { label: "Core", value: "Revision" }
    ],
    sections: [
      {
        eyebrow: "Weekly structure",
        title: "A realistic preparation week",
        bullets: [
          "Three reading blocks for compulsory and optional subjects.",
          "Two writing blocks for essay, precis or answers.",
          "Three MPT MCQ sessions before the screening test.",
          "One current affairs review block.",
          "One weekly mock or paper-section test."
        ]
      },
      {
        eyebrow: "Progress",
        title: "Keep the system honest",
        cards: [
          { title: "Done list", text: "Track completed topics, not hours spent near books." },
          { title: "Error list", text: "Every wrong MCQ or weak answer gets reviewed again." },
          { title: "Mock scores", text: "Use timed practice to expose weak papers early." },
          { title: "Revision sheet", text: "Condense each topic into short recall notes." }
        ]
      }
    ],
    related: [
      "/blog/offline-css-preparation-progress-app",
      "/blog/css-vocabulary-builder-app",
      "/blog/css-study-reels-app",
      "/css-syllabus",
      "/css-past-papers",
      "/mpt-past-papers",
      "/mpt-2027",
      "/pms-preparation"
    ],
    schemaKind: "article"
  },
  "/contact": {
    path: "/contact",
    kind: "contact",
    title: "Contact Aspirant",
    description:
      "Contact Aspirant support for CSS, PMS and MPT learning-app help, account questions and study-content feedback.",
    hero: {
      eyebrow: "Contact",
      headline: "Clear support for your preparation.",
      words: ["Support", "Feedback", "Aspirant"],
      summary:
        "Reach the Aspirant team for account support, technical help and feedback on CSS preparation content."
    },
    stats: [
      { label: "Share", value: "Exam target" },
      { label: "Share", value: "Subject mix" },
      { label: "Share", value: "Timeline" },
      { label: "Receive", value: "Notes" }
    ],
    sections: [
      {
        eyebrow: "Message guide",
        title: "What to send",
        bullets: [
          "Target exam and year.",
          "Current preparation stage.",
          "Optional subjects you are considering.",
          "Biggest issue: schedule, writing, MPT, current affairs or revision."
        ]
      }
    ],
    related: ["/exam-calendar", "/css-2027", "/css-eligibility", "/mpt-2027", "/study-plan"],
    schemaKind: "contact"
  },
  "/about": {
    path: "/about",
    kind: "about",
    title: "About Aspirant CSS & Editorial Standards",
    description:
      "Learn who builds Aspirant CSS, how its CSS, MPT and PMS preparation material is structured, and how official information is checked and corrected.",
    dateModified: "2026-08-26",
    hero: {
      eyebrow: "About Aspirant",
      headline: "Built to make competitive-exam preparation easier to navigate.",
      words: ["Independent", "Structured", "Source-aware"],
      summary:
        "Aspirant CSS is an independent DevZona Labs learning platform for students preparing CSS, MPT and PMS examinations in Pakistan."
    },
    sections: [
      {
        eyebrow: "Who we are",
        title: "An independent education product by DevZona Labs",
        body: [
          "Aspirant CSS and CSS Vista are official education brands owned and operated by DevZona Labs. Aspirant CSS combines a public preparation website with Android and iPhone apps, while CSS Vista identifies DevZona Labs' CSS preparation brand presence in Pakistan.",
          "The platform organizes lessons, solved papers, MCQs, vocabulary, current affairs, study reels, notes and progress tools around the way competitive-exam candidates actually revise.",
          "Aspirant is not affiliated with FPSC, PPSC or any government institution. Official advertisements, rules, syllabi, dates and results remain the responsibility of the issuing authority."
        ]
      },
      {
        eyebrow: "Editorial method",
        title: "How preparation guides are structured",
        steps: [
          "Begin with the relevant FPSC or PPSC syllabus and official examination structure.",
          "Review past-paper wording to understand recurring themes and command words.",
          "Organize the topic into concepts, evidence, application, practice and revision.",
          "Label expected schedules clearly and direct students to the official authority for confirmation.",
          "Revise material when a substantial content, product or examination update occurs."
        ]
      },
      {
        eyebrow: "Accuracy",
        title: "Sources, corrections and changing information",
        bullets: [
          "FPSC is the primary source for CSS and MPT advertisements, rules, syllabus, application details and results.",
          "PPSC is the primary source for Punjab PMS jobs, schedules, syllabi, applications and results.",
          "Statistics, office holders, policies and current-affairs facts can change and should be checked against a dated source.",
          "Readers can report an apparent content error through hamza@devzona.com for review."
        ]
      },
      {
        eyebrow: "Purpose",
        title: "What Aspirant aims to solve",
        body: [
          "Competitive-exam preparation is often scattered across PDFs, chats, books and disconnected advice. Aspirant aims to make the next study action obvious: understand the requirement, learn the concept, practise it, review the error and return at the right time.",
          "The website provides openly accessible planning and guidance. The mobile apps extend that system through interactive lessons, practice, offline access and saved progress."
        ]
      }
    ],
    related: ["/css-2027", "/css-syllabus", "/css-past-papers", "/blogs", "/aspirant-app", "/contact"],
    schemaKind: "webpage"
  },
  "/css-vista": {
    path: "/css-vista",
    kind: "brand",
    title: "CSS Vista Pakistan – Official CSS Preparation Brand",
    description:
      "CSS Vista is an official DevZona Labs education brand for CSS preparation in Pakistan, connected with Aspirant CSS study guides, solved papers, MCQs and mobile learning tools.",
    dateModified: "2026-08-26",
    hero: {
      eyebrow: "Official brand",
      headline: "CSS Vista Pakistan",
      words: ["CSS preparation", "DevZona Labs", "Aspirant CSS"],
      summary:
        "CSS Vista and Aspirant CSS are official education brands owned and operated by DevZona Labs for competitive-exam learners in Pakistan."
    },
    stats: [
      { label: "Official domain", value: "cssvista.pk" },
      { label: "Official domain", value: "cssvista.com.pk" },
      { label: "Owner", value: "DevZona Labs" },
      { label: "Learning platform", value: "Aspirant CSS" }
    ],
    sections: [
      {
        eyebrow: "Brand identity",
        title: "CSS Vista is an official DevZona Labs brand",
        body: [
          "CSS Vista is owned and operated by DevZona Labs as an active education brand serving CSS and competitive-exam aspirants in Pakistan. Aspirant CSS is also an official DevZona Labs brand and provides the connected web, Android and iPhone learning platform.",
          "The official CSS Vista domains are cssvista.pk and cssvista.com.pk. Official product information, preparation material, support and app links are published through the Aspirant CSS platform and verified DevZona Labs channels."
        ]
      },
      {
        eyebrow: "Preparation",
        title: "What CSS aspirants can access",
        cards: [
          { title: "CSS roadmap", text: "Understand examination stages, eligibility, syllabus boundaries and a realistic preparation sequence.", path: "/css-2027" },
          { title: "Subject selection", text: "Compare compulsory papers and optional groups before finalizing a subject combination.", path: "/css-subjects" },
          { title: "Solved papers", text: "Use past questions, answer structures and evidence planning to prepare for the written examination.", path: "/css-past-papers" },
          { title: "MPT preparation", text: "Prepare screening-test MCQs, mocks, past papers and an error-review system.", path: "/mpt-2027" },
          { title: "Study planning", text: "Build weekly reading, writing, revision and mock-test routines around measurable outputs.", path: "/study-plan" },
          { title: "Mobile learning", text: "Continue preparation through the Aspirant CSS Android and iPhone applications.", path: "/aspirant-app" }
        ]
      },
      {
        eyebrow: "Official identity",
        title: "How to verify CSS Vista",
        bullets: [
          "Official CSS Vista domain: cssvista.pk.",
          "Official CSS Vista domain: cssvista.com.pk.",
          "Official connected platform: www.aspirant.com.pk.",
          "Brand owner and operator: DevZona Labs.",
          "Support email: hamza@devzona.com."
        ]
      },
      {
        eyebrow: "Questions",
        title: "CSS Vista brand questions",
        faq: [
          {
            question: "Is CSS Vista an official DevZona Labs brand?",
            answer: "Yes. CSS Vista is an active education brand owned and operated by DevZona Labs for CSS preparation in Pakistan."
          },
          {
            question: "Are CSS Vista and Aspirant CSS both active brands?",
            answer: "Yes. CSS Vista and Aspirant CSS are official DevZona Labs education brands. Aspirant CSS provides the connected web and mobile learning platform."
          },
          {
            question: "Which CSS Vista domains are official?",
            answer: "The official domains are cssvista.pk and cssvista.com.pk. Both direct learners to the official DevZona Labs preparation platform."
          }
        ]
      }
    ],
    related: ["/", "/css-2027", "/css-subjects", "/css-past-papers", "/mpt-2027", "/aspirant-app", "/about"],
    schemaKind: "brand"
  },
  "/aspirant-app": {
    path: "/aspirant-app",
    kind: "app",
    title: "Aspirant CSS App for Android & iPhone",
    description:
      "Download Aspirant CSS for Android and iPhone: subject syllabus and lectures, solved papers, past and practice MCQs, MPT mocks, vocabulary, current affairs, study reels and offline progress.",
    dateModified: "2026-09-14",
    category: "Education App",
    featureGroups: appFeatureGroups,
    hero: {
      eyebrow: "Aspirant CSS mobile app",
      headline: "CSS, MPT and PMS preparation on Android and iPhone.",
      words: ["Lessons", "MCQs", "Solved papers", "Study reels"],
      summary:
        "Aspirant CSS is a Pakistan-focused exam preparation app for structured lessons, practice, revision and progress that stays available across online and offline study."
    },
    faq: [
      { question: "Is Aspirant CSS available on Android and iPhone?", answer: "Yes. Aspirant CSS is available from Google Play for Android and the Apple App Store for iPhone." },
      { question: "What can I study in the Aspirant CSS app?", answer: "The app includes CSS subject lessons, MPT preparation and mocks, past-paper MCQs, solved written papers, vocabulary, current affairs, notes and study reels." },
      { question: "Does Aspirant CSS work offline?", answer: "Available learning content, saved notes and local progress can continue offline. Live news, account synchronization and newly published updates require internet access." },
      { question: "Does the app support Urdu?", answer: "The app primarily uses English and includes Urdu support in relevant Islamic Studies and MPT learning areas." },
      { question: "Is Aspirant affiliated with FPSC or PPSC?", answer: "No. Aspirant CSS is an independent educational product by DevZona Labs. Candidates should verify official dates, rules and eligibility with FPSC or the relevant provincial commission." }
    ],
    related: [
      "/blog/aspirant-solved-css-past-papers-app",
      "/blog/css-past-paper-mcqs-app",
      "/blog/css-vocabulary-builder-app",
      "/blog/css-mpt-mock-tests-app",
      "/blog/css-study-reels-app",
      "/blog/offline-css-preparation-progress-app",
      "/blog/aspirant-css-app-complete-features",
      "/css-2027",
      "/contact"
    ],
    schemaKind: "app"
  },
  "/privacy-policy": {
    path: "/privacy-policy",
    kind: "legal",
    title: "Privacy Policy | Aspirant",
    description:
      "Aspirant privacy policy covering account data, study progress, notes, security, retention and privacy requests.",
    keywords:
      "Aspirant privacy policy, DevZona Labs privacy policy, CSS preparation app privacy, study app privacy Pakistan",
    hero: {
      eyebrow: "Privacy",
      headline: "Your study data, explained clearly.",
      summary:
        "This policy explains how DevZona Labs handles Aspirant account details, notes and learning progress.",
      hideActions: true
    },
    stats: [
      { label: "Updated", value: "03 Aug 2026" },
      { label: "Controller", value: "DevZona Labs" },
      { label: "Scope", value: "Web + App" },
      { label: "Contact", value: "Support" }
    ],
    sections: [
      {
        eyebrow: "Overview",
        title: "Who this policy covers",
        body: [
          "Aspirant is an independent learning platform operated by DevZona Labs. This policy applies to the Aspirant website, Android app, iOS app and related account services.",
          "Aspirant is not affiliated with, endorsed by, or acting on behalf of the Federal Public Service Commission (FPSC), any provincial public service commission, or any government institution. Always confirm examinations, eligibility, advertisements, dates and rules from the relevant official authority."
        ]
      },
      {
        eyebrow: "Information",
        title: "What we collect",
        bullets: [
          "Account information you provide, such as your name and email address.",
          "Authentication information, including a securely hashed password and temporary verification-code records used to protect your account.",
          "Learning information you choose to save, including notes, vocabulary progress and related study activity.",
          "Basic technical and security information needed to operate, secure and troubleshoot the service, such as request logs and app version details."
        ]
      },
      {
        eyebrow: "Use",
        title: "How we use information",
        bullets: [
          "Create and secure your account, verify your email address and restore access when you reset a password.",
          "Synchronize notes and learning progress when you choose to sign in.",
          "Send essential service emails, including verification and password-reset codes.",
          "Protect the platform from misuse, investigate faults and improve reliability.",
          "Display administrator messages or important app-update notices when they are enabled."
        ]
      },
      {
        eyebrow: "Sharing and retention",
        title: "When data is shared or kept",
        body: [
          "We do not sell personal information. We may use carefully selected service providers for hosting, databases, email delivery and security. They process information only to provide those services for Aspirant.",
          "We keep account and learning data while your account remains active, unless a longer period is required to resolve a dispute, prevent abuse or meet a legal obligation. Temporary verification codes expire automatically."
        ]
      },
      {
        eyebrow: "Your choices",
        title: "Access, correction and deletion",
        body: [
          "You can request access to, correction of, or deletion of personal information associated with your Aspirant account. To make a request, email hamza@devzona.com from the email address connected to your account and include enough detail for us to verify the request.",
          "We may need to retain limited records where necessary for security, fraud prevention, legal compliance or to complete an unresolved transaction."
        ]
      },
      {
        eyebrow: "Security and updates",
        title: "How we protect and update this policy",
        body: [
          "We use reasonable technical and organizational measures designed to protect data, including hashed passwords, authenticated requests and time-limited verification codes. No online service can guarantee absolute security.",
          "We may update this policy when the service or legal requirements change. The current version is published on this page with its update date. Material changes may also be communicated through the app or email where appropriate."
        ]
      }
    ],
    related: ["/terms-of-use", "/contact", "/"],
    schemaKind: "webpage"
  },
  "/terms-of-use": {
    path: "/terms-of-use",
    kind: "legal",
    title: "Terms of Use | Aspirant",
    description:
      "Aspirant terms of use for its independent CSS, PMS and MPT learning platform operated by DevZona Labs.",
    keywords:
      "Aspirant terms of use, DevZona Labs terms, CSS preparation app terms, FPSC disclaimer",
    hero: {
      eyebrow: "Terms",
      headline: "Use Aspirant with clarity.",
      summary:
        "These terms set the rules for using Aspirant’s independent study tools, content and account services.",
      hideActions: true
    },
    stats: [
      { label: "Updated", value: "03 Aug 2026" },
      { label: "Operator", value: "DevZona Labs" },
      { label: "Use", value: "Educational" },
      { label: "Official dates", value: "Verify" }
    ],
    sections: [
      {
        eyebrow: "Agreement",
        title: "Using Aspirant",
        body: [
          "By creating an account or using Aspirant, you agree to these Terms of Use and the Privacy Policy. If you do not agree, do not create an account or use account-based features.",
          "Aspirant provides educational planning, practice and learning tools. It does not guarantee examination eligibility, registration, results, employment, allocation, selection or any particular outcome."
        ]
      },
      {
        eyebrow: "Independent platform",
        title: "No government affiliation",
        body: [
          "Aspirant belongs to DevZona Labs. It is an independent private platform and is not affiliated with, approved by, sponsored by, or representative of FPSC, PPSC, any other public service commission, or any government body.",
          "Official notices, dates, syllabi, eligibility criteria, advertisements and application procedures can change. You are responsible for checking the relevant official source before making any decision or submitting an application."
        ]
      },
      {
        eyebrow: "Accounts",
        title: "Your account responsibilities",
        bullets: [
          "Provide accurate account information and keep your login credentials private.",
          "Use one account for yourself and do not share it or attempt to access another user’s account.",
          "Tell us promptly if you believe your account has been accessed without permission.",
          "We may suspend or disable an account that violates these terms, threatens platform security or is used unlawfully."
        ]
      },
      {
        eyebrow: "Content",
        title: "Educational content and permitted use",
        bullets: [
          "Use Aspirant content for your personal, non-commercial study and preparation.",
          "Do not copy, scrape, republish, sell, redistribute or create a competing service from our materials without written permission.",
          "Treat study material, expected schedules and guidance as educational support, not official advice or a substitute for the issuing authority’s notice.",
          "Report an apparent factual error through hamza@devzona.com so it can be reviewed."
        ]
      },
      {
        eyebrow: "Service and subscriptions",
        title: "Availability, updates and promotional access",
        body: [
          "Features may change, be added, paused or removed as Aspirant develops. We may release updates to improve security, reliability or learning features; some updates may be required to continue using the app.",
          "Where a premium plan is shown as included or promotional, it is subject to the terms displayed in the app. Paid products, if introduced later, will include clear pricing and billing terms before purchase."
        ]
      },
      {
        eyebrow: "Liability and contact",
        title: "Important limits",
        body: [
          "To the extent permitted by law, Aspirant and DevZona Labs provide the platform on an “as available” basis and are not liable for losses caused by reliance on unofficial, incomplete or outdated information. Our total responsibility is limited to the amount you paid to use the affected service, if any.",
          "For questions about these terms, contact hamza@devzona.com. These terms are governed by the laws applicable in Pakistan, subject to any consumer protections that apply to you."
        ]
      }
    ],
    related: ["/privacy-policy", "/contact", "/"],
    schemaKind: "webpage"
  },
  "/answer-writing-tips": {
    path: "/answer-writing-tips",
    kind: "answer-tip",
    title: "How to Write CSS & PMS Answers: 52 Subject Comparisons",
    description: "Browse 52 subject-wise CSS and PMS answer comparisons. See how boring answers become stronger through evidence, dates, calculations and critical analysis.",
    category: "Answer Writing",
    datePublished: "2026-10-20",
    dateModified: "2026-10-21",
    keywords: "CSS answer writing tips, PMS answer writing, 52 CSS subjects, quantitative answer examples, boring vs strong answers",
    sections: [
      { title: "52 subject-wise answer comparisons", body: ["Search compulsory and optional subjects to compare a boring three-point answer with a stronger, evidence-led example. Each entry includes its topic and source links for further reading."] },
      { title: "Answer-writing formula", body: ["Argument, evidence, legal context, critical analysis and future implication."] }
    ],
    related: ["/blog/css-answer-writing", "/css-past-papers", "/blog/current-affairs-for-css", "/aspirant-app"],
    schemaKind: "article"
  },
  "/sitemap": {
    path: "/sitemap",
    kind: "sitemap",
    title: "Aspirant Site Map",
    description:
      "A human-readable map of Aspirant CSS pages for CSS 2027, PMS, MPT, syllabus, past papers, eligibility, subjects and study planning.",
    hero: {
      eyebrow: "Site map",
      headline: "Aspirant pages",
      words: ["CSS", "MPT", "PMS"],
      summary:
        "Core routes for CSS 2027, exam calendar, eligibility, subject selection and study planning."
    },
    stats: [
      { label: "CSS", value: "2027" },
      { label: "MPT", value: "Tracker" },
      { label: "PMS", value: "PPSC" },
      { label: "Guides", value: "5" }
    ],
    sections: [
      {
        eyebrow: "Pages",
        title: "Core routes",
        cards: [
          { title: "Home", text: "Aspirant CSS preparation overview.", path: "/" },
          { title: "Exam Calendar", text: "CSS, MPT and PMS planning calendar.", path: "/exam-calendar" },
          { title: "CSS 2027", text: "Long-range CSS preparation roadmap.", path: "/css-2027" },
          { title: "CSS Syllabus", text: "Compulsory papers, optional groups and syllabus study method.", path: "/css-syllabus" },
          { title: "CSS Past Papers", text: "Solved papers and subject-wise preparation method.", path: "/css-past-papers" },
          { title: "Answer Writing Tips", text: "52 boring-versus-strong CSS/PMS answer examples.", path: "/answer-writing-tips" },
          { title: "Eligibility", text: "CSS eligibility planning tool.", path: "/css-eligibility" },
          { title: "Subjects", text: "Compulsory and optional subject groups.", path: "/css-subjects" },
          { title: "MPT", text: "CSS MPT preparation guide.", path: "/mpt-2027" },
          { title: "MPT Past Papers", text: "Solved MCQs, mocks and error-log method.", path: "/mpt-past-papers" },
          { title: "MPT 2026 Answer Keys", text: "Batch 1 morning and Batch 2 evening answer-key images.", path: "/mpt-result-2026" },
          { title: "PMS Preparation", text: "PMS syllabus, past-paper and weekly preparation system.", path: "/pms-preparation" },
          { title: "Study Plan", text: "Weekly preparation system.", path: "/study-plan" },
          { title: "Blogs", text: "Beginner CSS guides and subject-selection help.", path: "/blogs" },
          { title: "CSS Vista", text: "Official CSS Vista Pakistan brand and ownership information.", path: "/css-vista" },
          { title: "About Aspirant", text: "Publisher details, editorial method and source policy.", path: "/about" },
          { title: "Contact", text: "Early access and feedback.", path: "/contact" },
          { title: "Aspirant Mobile App", text: "App information, privacy and support links.", path: "/aspirant-app" },
          { title: "Privacy Policy", text: "How Aspirant handles account and study data.", path: "/privacy-policy" },
          { title: "Terms of Use", text: "Rules and independent-platform disclosure.", path: "/terms-of-use" }
        ]
      }
    ],
    related: ["/", "/css-2027", "/css-syllabus", "/css-past-papers", "/mpt-past-papers", "/pms-preparation"],
    schemaKind: "collection"
  },
  ...subjectSyllabusPages,
  ...blogPages,
  "/hk/dev": {
    path: "/hk/dev",
    kind: "dev",
    title: "Study Planner Dev",
    description:
      "Developer route for multi-book upload, AI sectioning, calendar generation and progress tracking.",
    noindex: true,
    schemaKind: "webpage"
  }
};

export function getPage(path) {
  const page = pages[path] || {
    path,
    kind: "not-found",
    title: "Page Not Found",
    description: "This page does not exist on Aspirant CSS.",
    noindex: true,
    schemaKind: "webpage"
  };

  return enrichPageSeo(page);
}

export function buildSchema(path, page) {
  const currentPage = page || getPage(path);

  if (currentPage.noindex) {
    return {
      "@context": "https://schema.org",
      ...webPageSchema(currentPage)
    };
  }

  if (currentPage.kind === "subject-syllabus") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        webPageSchema(currentPage),
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: brand.url },
            { "@type": "ListItem", position: 2, name: "CSS syllabus", item: `${brand.url}/css-syllabus` },
            { "@type": "ListItem", position: 3, name: currentPage.title, item: `${brand.url}${path}` }
          ]
        }
      ]
    };
  }

  if (currentPage.kind === "home") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          ...devZonaOrganizationSchema(),
          areaServed: ["Pakistan"],
          knowsAbout: [
            "CSS preparation",
            "CSS MPT preparation",
            "PMS Punjab schedule tracking",
            "CSS optional subjects",
            "CSS eligibility",
            "CSS essay writing",
            "Solved CSS written past papers",
            "CSS past-paper MCQs",
            "MPT mock tests",
            "CSS vocabulary with Urdu meanings",
            "CSS current affairs",
            "CSS study reels",
            "Offline CSS preparation",
            "Learning progress tracking"
          ]
        },
        ...officialBrandSchemas(),
        {
          "@type": "WebSite",
          "@id": `${brand.url}/#website`,
          name: brand.name,
          url: brand.url,
          publisher: { "@id": `${brand.url}/#organization` },
          inLanguage: "en"
        },
        webPageSchema(currentPage)
      ]
    };
  }

  if (currentPage.kind === "guide" || currentPage.kind === "answer-tip") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        articleSchema(currentPage),
        faqSchema(currentPage),
        breadcrumbSchema(currentPage),
        webPageSchema(currentPage)
      ].filter(Boolean)
    };
  }

  if (currentPage.kind === "blog") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        articleSchema(currentPage),
        ...featureAppSchemas(currentPage),
        faqSchema(currentPage),
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: brand.url },
            { "@type": "ListItem", position: 2, name: "Blogs", item: `${brand.url}/blogs` },
            { "@type": "ListItem", position: 3, name: currentPage.title, item: `${brand.url}${currentPage.path}` }
          ]
        },
        webPageSchema(currentPage)
      ].filter(Boolean)
    };
  }

  if (currentPage.kind === "blogs") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        webPageSchema(currentPage),
        {
          "@type": "CollectionPage",
          name: currentPage.title,
          description: currentPage.description,
          hasPart: blogPosts.map((post) => ({
            "@type": "BlogPosting",
            headline: post.title,
            description: post.description,
            articleSection: post.category,
            dateModified: post.dateModified,
            url: `${brand.url}${post.path}`
          }))
        }
      ]
    };
  }

  if (currentPage.kind === "brand") {
    const cssVistaBrand = officialBrandSchemas().find(
      (officialBrand) => officialBrand.name === "CSS Vista"
    );

    return {
      "@context": "https://schema.org",
      "@graph": [
        webPageSchema(currentPage),
        breadcrumbSchema(currentPage),
        faqSchema(currentPage),
        devZonaOrganizationSchema(),
        ...officialBrandSchemas(),
        {
          "@type": "AboutPage",
          "@id": `${brand.url}/css-vista#page`,
          name: currentPage.title,
          description: currentPage.description,
          url: `${brand.url}/css-vista`,
          mainEntity: { "@id": cssVistaBrand["@id"] },
          publisher: { "@id": `${brand.url}/#organization` }
        }
      ].filter(Boolean)
    };
  }

  if (currentPage.kind === "contact") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        webPageSchema(currentPage),
        {
          "@type": "ContactPage",
          name: currentPage.title,
          url: `${brand.url}${currentPage.path}`,
          description: currentPage.description,
          mainEntity: {
            "@type": "Organization",
            name: "DevZona Labs",
            email: "hamza@devzona.com",
            contactPoint: {
              "@type": "ContactPoint",
              email: "hamza@devzona.com",
              contactType: "customer support",
              availableLanguage: ["English", "Urdu"]
            }
          }
        }
      ]
    };
  }

  if (currentPage.kind === "about") {
    return {
      "@context": "https://schema.org",
      "@graph": [
        webPageSchema(currentPage),
        breadcrumbSchema(currentPage),
        {
          "@type": "AboutPage",
          name: currentPage.title,
          description: currentPage.description,
          url: `${brand.url}${currentPage.path}`,
          mainEntity: {
            ...devZonaOrganizationSchema()
          }
        }
      ]
    };
  }

  if (currentPage.kind === "app") {
    const sharedAppProperties = {
      "@type": "MobileApplication",
      name: "Aspirant CSS – CSS MPT Exam Prep",
      alternateName: "Aspirant CSS",
      description: currentPage.description,
      applicationCategory: "EducationalApplication",
      applicationSubCategory: "Test Preparation",
      image: absoluteAssetUrl(brand.logo),
      featureList: appFeatureList,
      author: {
        "@type": "Organization",
        name: "DevZona Labs",
        url: brand.url,
        email: "hamza@devzona.com"
      },
      provider: { "@id": `${brand.url}/#organization` },
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "PKR",
        availability: "https://schema.org/InStock"
      },
      isAccessibleForFree: true,
      countriesSupported: "PK",
      inLanguage: ["en-PK", "ur-PK"]
    };

    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          ...webPageSchema(currentPage),
          mainEntity: [
            { "@id": `${brand.url}/aspirant-app#android-app` },
            { "@id": `${brand.url}/aspirant-app#ios-app` }
          ]
        },
        {
          "@type": "Organization",
          "@id": `${brand.url}/#organization`,
          name: brand.name,
          legalName: "DevZona Labs",
          url: brand.url,
          logo: absoluteAssetUrl(brand.logo),
          email: "hamza@devzona.com",
          sameAs: [appStores.android.url, appStores.ios.url, socialProfiles.instagram.url]
        },
        {
          ...sharedAppProperties,
          "@id": `${brand.url}/aspirant-app#android-app`,
          operatingSystem: "Android",
          softwareVersion: appStores.android.version,
          identifier: appStores.android.identifier,
          url: appStores.android.url,
          downloadUrl: appStores.android.url,
          installUrl: appStores.android.url,
          sameAs: appStores.android.url
        },
        {
          ...sharedAppProperties,
          "@id": `${brand.url}/aspirant-app#ios-app`,
          operatingSystem: "iOS",
          softwareVersion: appStores.ios.version,
          identifier: appStores.ios.identifier,
          url: appStores.ios.url,
          downloadUrl: appStores.ios.url,
          installUrl: appStores.ios.url,
          sameAs: appStores.ios.url
        },
        faqSchema(currentPage),
        breadcrumbSchema(currentPage)
      ].filter(Boolean)
    };
  }

  return {
    "@context": "https://schema.org",
    ...webPageSchema(currentPage)
  };
}
